(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Tomate-Banner-Producto-01"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGaleria(wrapper) {
    if (wrapper.dataset.bp01GaleriaInit === 'true') return;
    wrapper.dataset.bp01GaleriaInit = 'true';

    var pista = wrapper.querySelector('[data-bp01-pista]');
    if (!pista) return;

    var items = pista.querySelectorAll('.bp01-galeria-item');

    function ajustarLayout() {
      if (items.length === 0) return;
      var anchoItem = items[0].offsetWidth;
      var gap = parseFloat(window.getComputedStyle(pista).columnGap || window.getComputedStyle(pista).gap || '0') || 0;
      var anchoTotal = items.length * anchoItem + Math.max(0, items.length - 1) * gap;
      var anchoVisible = pista.clientWidth;

      if (anchoTotal <= anchoVisible) {
        pista.classList.add('bp01-pista-centrada');
        pista.style.paddingLeft = '';
        pista.style.paddingRight = '';
      } else {
        pista.classList.remove('bp01-pista-centrada');
        var padding = Math.max(0, (anchoVisible - anchoItem) / 2);
        pista.style.paddingLeft = padding + 'px';
        pista.style.paddingRight = padding + 'px';
      }
    }

    window.addEventListener('resize', function () {
      ajustarLayout();
    });

    var arrastrando = false;
    var inicioX = 0;
    var scrollInicio = 0;
    pista.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      arrastrando = true;
      inicioX = e.clientX;
      scrollInicio = pista.scrollLeft;
      pista.style.scrollBehavior = 'auto';
    });
    pista.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      pista.scrollLeft = scrollInicio - (e.clientX - inicioX);
    });
    function finArrastre() {
      arrastrando = false;
      pista.style.scrollBehavior = '';
    }
    pista.addEventListener('pointerup', finArrastre);
    pista.addEventListener('pointercancel', finArrastre);
    pista.addEventListener('pointerleave', finArrastre);

    setTimeout(function () {
      ajustarLayout();
    }, 80);

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        ajustarLayout();
      });
      ro.observe(pista);
    }
  }

  function initAnim(seccion) {
    if (seccion.dataset.bp01AnimInit === 'true') return;
    seccion.dataset.bp01AnimInit = 'true';

    var tipoAnim = '';
    seccion.classList.forEach(function (c) {
      if (c.indexOf('bp01-anim-') === 0 && c !== 'bp01-anim-visible' && c.indexOf('bp01-anim-seq-') !== 0) tipoAnim = c;
    });

    if (tipoAnim === 'bp01-anim-ninguna' || tipoAnim === '') {
      seccion.classList.add('bp01-anim-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      seccion.classList.add('bp01-anim-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('bp01-anim-visible');
          observer.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    observer.observe(seccion);
  }

  function init() {
    document.querySelectorAll('[data-bp01-seccion]').forEach(initAnim);
    document.querySelectorAll('[data-bp01-galeria]').forEach(initGaleria);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = e.target.querySelector('[data-bp01-seccion]');
    if (seccion) {
      seccion.dataset.bp01AnimInit = '';
      initAnim(seccion);
    }
    var galerias = e.target.querySelectorAll('[data-bp01-galeria]');
    galerias.forEach(function (g) {
      g.dataset.bp01GaleriaInit = '';
      initGaleria(g);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tomate-Header-Desktop-01"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initHeader(header) {
    if (header.dataset.hdrInit === 'true') return;
    header.dataset.hdrInit = 'true';

    initSticky(header);
    initBuscador(header);
    initDrawer(header);
    initCarrito(header);
    initLogoHover(header);
    initSubmenus(header);
  }

  function initSubmenus(header) {
    var items = header.querySelectorAll('[data-hdr-item-sub]');
    items.forEach(function (item) {
      var temporizador = null;

      item.addEventListener('mouseenter', function () {
        if (temporizador) { clearTimeout(temporizador); temporizador = null; }
        item.classList.add('hdr-sub-abierto');
      });

      item.addEventListener('mouseleave', function () {
        temporizador = setTimeout(function () {
          item.classList.remove('hdr-sub-abierto');
        }, 180);
      });
    });

    var toggles = header.querySelectorAll('[data-hdr-drawer-toggle]');
    toggles.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var item = boton.closest('[data-hdr-drawer-item]');
        if (!item) return;
        var sub = item.querySelector('[data-hdr-drawer-sub]');
        var abierto = item.classList.contains('hdr-drawer-abierto');

        if (abierto) {
          item.classList.remove('hdr-drawer-abierto');
          boton.setAttribute('aria-expanded', 'false');
          if (sub) sub.style.maxHeight = '0px';
        } else {
          item.classList.add('hdr-drawer-abierto');
          boton.setAttribute('aria-expanded', 'true');
          if (sub) sub.style.maxHeight = sub.scrollHeight + 'px';
        }
      });
    });
  }

  function initLogoHover(header) {
    var logo = header.querySelector('.hdr-logo-zoom-on');
    if (!logo) return;

    var expansionActiva = header.dataset.hdrExpansion === 'true';
    if (!expansionActiva) return;

    var placeholder = header.parentNode.querySelector('[data-hdr-placeholder]');
    var esDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

    logo.addEventListener('mouseenter', function () {
      if (!esDesktop()) return;
      header.classList.add('hdr-logo-hover');
      if (placeholder && header.classList.contains('hdr-pegado')) {
        setTimeout(function () {
          var mb = parseFloat(window.getComputedStyle(header).marginBottom) || 0;
          placeholder.style.setProperty('height', (header.offsetHeight + mb) + 'px', 'important');
        }, 50);
      }
    });

    logo.addEventListener('mouseleave', function () {
      header.classList.remove('hdr-logo-hover');
      if (placeholder && header.classList.contains('hdr-pegado')) {
        setTimeout(function () {
          var mb = parseFloat(window.getComputedStyle(header).marginBottom) || 0;
          placeholder.style.setProperty('height', (header.offsetHeight + mb) + 'px', 'important');
        }, 350);
      }
    });
  }

  function initSticky(header) {
    var modo = header.dataset.hdrSticky;

    if (modo === 'nunca') return;

    var placeholder = header.parentNode.querySelector('[data-hdr-placeholder]');
    var posicionOriginal = 0;
    var alturaHeader = 0;

    function alturaTotal() {
      var mb = parseFloat(window.getComputedStyle(header).marginBottom) || 0;
      return header.offsetHeight + mb;
    }

    function medir() {
      var estabaPegado = header.classList.contains('hdr-pegado');
      if (estabaPegado) {
        header.classList.remove('hdr-pegado');
        if (placeholder) placeholder.style.removeProperty('height');
      }
      alturaHeader = alturaTotal();
      posicionOriginal = header.getBoundingClientRect().top + window.scrollY;
      if (estabaPegado) {
        if (placeholder) placeholder.style.setProperty('height', alturaHeader + 'px', 'important');
        header.classList.add('hdr-pegado');
      }
    }

    function evaluarPegado() {
      var y = window.scrollY;
      var pegado = header.classList.contains('hdr-pegado');

      if (!pegado) {
        alturaHeader = alturaTotal();
        var rectTop = header.getBoundingClientRect().top;
        if (rectTop >= 0) {
          posicionOriginal = rectTop + y;
        }
      }

      if (!pegado && y > posicionOriginal) {
        if (placeholder) placeholder.style.setProperty('height', alturaHeader + 'px', 'important');
        header.classList.add('hdr-pegado');
      } else if (pegado && y < posicionOriginal - 2) {
        header.classList.remove('hdr-pegado');
        if (placeholder) placeholder.style.removeProperty('height');
      }
    }

    function init() {
      medir();
      evaluarPegado();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('load', init);

    window.addEventListener('resize', function () {
      medir();
      evaluarPegado();
    }, { passive: true });

    if (modo === 'siempre') {
      window.addEventListener('scroll', evaluarPegado, { passive: true });
      return;
    }

    var lastY = 0;
    var oculto = false;
    var umbral = 100;

    window.addEventListener('scroll', function () {
      evaluarPegado();

      var y = window.scrollY;
      var diff = y - lastY;

      if (y <= umbral) {
        if (oculto) { header.classList.remove('hdr-oculto'); oculto = false; }
      } else if (diff > 4 && !oculto) {
        header.classList.add('hdr-oculto'); oculto = true;
      } else if (diff < -4 && oculto) {
        header.classList.remove('hdr-oculto'); oculto = false;
      }

      lastY = y;
    }, { passive: true });
  }

  function initBuscador(header) {
    var toggle = header.querySelector('[data-hdr-buscador-toggle]');
    var panel = header.querySelector('[data-hdr-buscador]');
    var cerrar = header.querySelector('[data-hdr-buscador-cerrar]');
    var input = header.querySelector('[data-hdr-buscador-input]');

    if (!toggle || !panel) return;

    function abrir() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      setTimeout(function () { if (input) input.focus(); }, 50);
    }

    function cerrarPanel() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      if (panel.hidden) abrir(); else cerrarPanel();
    });

    if (cerrar) cerrar.addEventListener('click', cerrarPanel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) cerrarPanel();
    });

    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (!panel.contains(e.target) && !toggle.contains(e.target)) cerrarPanel();
    });
  }

  function initDrawer(header) {
    var hamburguesa = header.querySelector('[data-hdr-hamburguesa]');
    var drawer = header.querySelector('[data-hdr-drawer]');
    var cierres = header.querySelectorAll('[data-hdr-drawer-cerrar]');

    if (!hamburguesa || !drawer) return;

    function abrir() {
      drawer.classList.add('hdr-drawer-abierto');
      drawer.setAttribute('aria-hidden', 'false');
      hamburguesa.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function cerrar() {
      drawer.classList.remove('hdr-drawer-abierto');
      drawer.setAttribute('aria-hidden', 'true');
      hamburguesa.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    hamburguesa.addEventListener('click', function () {
      if (drawer.classList.contains('hdr-drawer-abierto')) cerrar();
      else abrir();
    });

    cierres.forEach(function (el) {
      el.addEventListener('click', cerrar);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('hdr-drawer-abierto')) cerrar();
    });
  }

  function initCarrito(header) {
    var contador = header.querySelector('[data-hdr-carrito-contador]');
    if (!contador) return;

    var ultimoCount = parseInt(contador.textContent, 10) || 0;

    function actualizar(count, esAdicion) {
      contador.textContent = count;
      if (parseInt(count, 10) > 0) {
        contador.removeAttribute('data-vacio');
      } else {
        contador.setAttribute('data-vacio', 'true');
      }

      if (esAdicion) {
        contador.classList.remove('hdr-badge-active');
        void contador.offsetWidth;
        contador.classList.add('hdr-badge-active');
        contador.classList.add('hdr-badge-anadido');

        setTimeout(function () {
          contador.classList.remove('hdr-badge-active');
        }, 700);

        setTimeout(function () {
          contador.classList.remove('hdr-badge-anadido');
        }, 2000);
      }

      ultimoCount = parseInt(count, 10) || 0;
    }

    actualizar(ultimoCount, false);

    function refresh(esAdicion) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var nuevo = data.item_count;
          var esAumento = nuevo > ultimoCount;
          actualizar(nuevo, esAdicion === true && esAumento);
        })
        .catch(function () {});
    }

    document.addEventListener('cart:updated', function (e) {
      if (e.detail && typeof e.detail.item_count !== 'undefined') {
        var nuevo = e.detail.item_count;
        var esAumento = nuevo > ultimoCount;
        actualizar(nuevo, esAumento);
      } else {
        refresh(true);
      }
    });

    document.addEventListener('product:added', function () { refresh(true); });
    document.addEventListener('cart:added', function () { refresh(true); });
    document.addEventListener('variant:added', function () { refresh(true); });

    document.body.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        setTimeout(function () { refresh(true); }, 600);
      }
    }, true);

    var origFetch = window.fetch;
    if (origFetch && !window.__hdrCartFetchHooked) {
      window.__hdrCartFetchHooked = true;
      window.fetch = function () {
        var url = arguments[0];
        var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
        var esCartAdd = urlStr.indexOf('/cart/add') !== -1;
        var resultado = origFetch.apply(this, arguments);
        if (esCartAdd) {
          resultado.then(function () {
            setTimeout(function () {
              document.querySelectorAll('[data-hdr-header]').forEach(function (h) {
                var c = h.querySelector('[data-hdr-carrito-contador]');
                if (c) {
                  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (data) {
                    var ev = new CustomEvent('cart:updated', { detail: { item_count: data.item_count } });
                    document.dispatchEvent(ev);
                  });
                }
              });
            }, 100);
          }).catch(function () {});
        }
        return resultado;
      };
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hdr-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target.querySelector('[data-hdr-header]');
    if (h) {
      h.dataset.hdrInit = '';
      initHeader(h);
    }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tomate-Header-Movil-01"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initHeader(header) {
    if (header.dataset.hmovInit === 'true') return;
    header.dataset.hmovInit = 'true';

    initSticky(header);
    initBuscador(header);
    initDrawer(header);
    initCarrito(header);
    initLogoHover(header);
    initSubmenus(header);
  }

  function initSubmenus(header) {
    var items = header.querySelectorAll('[data-hmov-item-sub]');
    items.forEach(function (item) {
      var temporizador = null;

      item.addEventListener('mouseenter', function () {
        if (temporizador) { clearTimeout(temporizador); temporizador = null; }
        item.classList.add('hmov-sub-abierto');
      });

      item.addEventListener('mouseleave', function () {
        temporizador = setTimeout(function () {
          item.classList.remove('hmov-sub-abierto');
        }, 180);
      });
    });

    var toggles = header.querySelectorAll('[data-hmov-drawer-toggle]');
    toggles.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var item = boton.closest('[data-hmov-drawer-item]');
        if (!item) return;
        var sub = item.querySelector('[data-hmov-drawer-sub]');
        var abierto = item.classList.contains('hmov-drawer-abierto');

        if (abierto) {
          item.classList.remove('hmov-drawer-abierto');
          boton.setAttribute('aria-expanded', 'false');
          if (sub) sub.style.maxHeight = '0px';
        } else {
          item.classList.add('hmov-drawer-abierto');
          boton.setAttribute('aria-expanded', 'true');
          if (sub) sub.style.maxHeight = sub.scrollHeight + 'px';
        }
      });
    });
  }

  function initLogoHover(header) {
    var logo = header.querySelector('.hmov-logo-zoom-on');
    if (!logo) return;

    var expansionActiva = header.dataset.hmovExpansion === 'true';
    if (!expansionActiva) return;

    var placeholder = header.parentNode.querySelector('[data-hmov-placeholder]');
    var esDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

    logo.addEventListener('mouseenter', function () {
      if (!esDesktop()) return;
      header.classList.add('hmov-logo-hover');
      if (placeholder && header.classList.contains('hmov-pegado')) {
        setTimeout(function () {
          var mb = parseFloat(window.getComputedStyle(header).marginBottom) || 0;
          placeholder.style.setProperty('height', (header.offsetHeight + mb) + 'px', 'important');
        }, 50);
      }
    });

    logo.addEventListener('mouseleave', function () {
      header.classList.remove('hmov-logo-hover');
      if (placeholder && header.classList.contains('hmov-pegado')) {
        setTimeout(function () {
          var mb = parseFloat(window.getComputedStyle(header).marginBottom) || 0;
          placeholder.style.setProperty('height', (header.offsetHeight + mb) + 'px', 'important');
        }, 350);
      }
    });
  }

  function initSticky(header) {
    var modo = header.dataset.hmovSticky;

    if (modo === 'nunca') return;

    var placeholder = header.parentNode.querySelector('[data-hmov-placeholder]');
    var posicionOriginal = 0;
    var alturaHeader = 0;

    function alturaTotal() {
      var mb = parseFloat(window.getComputedStyle(header).marginBottom) || 0;
      return header.offsetHeight + mb;
    }

    function medir() {
      var estabaPegado = header.classList.contains('hmov-pegado');
      if (estabaPegado) {
        header.classList.remove('hmov-pegado');
        if (placeholder) placeholder.style.removeProperty('height');
      }
      alturaHeader = alturaTotal();
      posicionOriginal = header.getBoundingClientRect().top + window.scrollY;
      if (estabaPegado) {
        if (placeholder) placeholder.style.setProperty('height', alturaHeader + 'px', 'important');
        header.classList.add('hmov-pegado');
      }
    }

    function evaluarPegado() {
      var y = window.scrollY;
      var pegado = header.classList.contains('hmov-pegado');

      if (!pegado) {
        alturaHeader = alturaTotal();
        var rectTop = header.getBoundingClientRect().top;
        if (rectTop >= 0) {
          posicionOriginal = rectTop + y;
        }
      }

      if (!pegado && y > posicionOriginal) {
        if (placeholder) placeholder.style.setProperty('height', alturaHeader + 'px', 'important');
        header.classList.add('hmov-pegado');
      } else if (pegado && y < posicionOriginal - 2) {
        header.classList.remove('hmov-pegado');
        if (placeholder) placeholder.style.removeProperty('height');
      }
    }

    function init() {
      medir();
      evaluarPegado();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('load', init);

    window.addEventListener('resize', function () {
      medir();
      evaluarPegado();
    }, { passive: true });

    if (modo === 'siempre') {
      window.addEventListener('scroll', evaluarPegado, { passive: true });
      return;
    }

    var lastY = 0;
    var oculto = false;
    var umbral = 100;

    window.addEventListener('scroll', function () {
      evaluarPegado();

      var y = window.scrollY;
      var diff = y - lastY;

      if (y <= umbral) {
        if (oculto) { header.classList.remove('hmov-oculto'); oculto = false; }
      } else if (diff > 4 && !oculto) {
        header.classList.add('hmov-oculto'); oculto = true;
      } else if (diff < -4 && oculto) {
        header.classList.remove('hmov-oculto'); oculto = false;
      }

      lastY = y;
    }, { passive: true });
  }

  function initBuscador(header) {
    var toggle = header.querySelector('[data-hmov-buscador-toggle]');
    var panel = header.querySelector('[data-hmov-buscador]');
    var cerrar = header.querySelector('[data-hmov-buscador-cerrar]');
    var input = header.querySelector('[data-hmov-buscador-input]');

    if (!toggle || !panel) return;

    function abrir() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      setTimeout(function () { if (input) input.focus(); }, 50);
    }

    function cerrarPanel() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      if (panel.hidden) abrir(); else cerrarPanel();
    });

    if (cerrar) cerrar.addEventListener('click', cerrarPanel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) cerrarPanel();
    });

    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (!panel.contains(e.target) && !toggle.contains(e.target)) cerrarPanel();
    });
  }

  function initDrawer(header) {
    var hamburguesa = header.querySelector('[data-hmov-hamburguesa]');
    var drawer = header.querySelector('[data-hmov-drawer]');

    if (!hamburguesa || !drawer) return;

    if (drawer.parentNode !== document.body) {
      var estilosHeader = window.getComputedStyle(header);
      var varsCopiar = ['--hmov-fondo', '--hmov-drawer-ancho', '--hmov-drawer-margen-arriba', '--hmov-drawer-margen-abajo', '--hmov-drawer-margen-lado', '--hmov-drawer-radio', '--hmov-drawer-imagen-ancho', '--hmov-drawer-imagen-radio', '--hmov-drawer-titulo-tam', '--hmov-drawer-titulo-color', '--hmov-drawer-titulo-align', '--hmov-drawer-subtitulo-tam', '--hmov-drawer-subtitulo-color', '--hmov-drawer-subtitulo-align', '--hmov-subenlace-tam', '--hmov-subenlace-color', '--hmov-drawer-enlace-pad', '--hmov-drawer-enlace-tam', '--hmov-color-enlace', '--hmov-color-enlace-hover', '--hmov-color-icono', '--hmov-sub-color', '--hmov-font-enlaces', '--hmov-font-logo', '--hmov-font-boton'];
      varsCopiar.forEach(function (v) {
        var valor = estilosHeader.getPropertyValue(v);
        if (valor) drawer.style.setProperty(v, valor.trim());
      });
      document.body.appendChild(drawer);
    }

    var cierres = drawer.querySelectorAll('[data-hmov-drawer-cerrar]');

    function abrir() {
      drawer.classList.add('hmov-drawer-abierto');
      drawer.setAttribute('aria-hidden', 'false');
      hamburguesa.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function cerrar() {
      drawer.classList.remove('hmov-drawer-abierto');
      drawer.setAttribute('aria-hidden', 'true');
      hamburguesa.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    hamburguesa.addEventListener('click', function () {
      if (drawer.classList.contains('hmov-drawer-abierto')) cerrar();
      else abrir();
    });

    cierres.forEach(function (el) {
      el.addEventListener('click', cerrar);
    });

    // Los enlaces con ancla (p. ej. la ventana de afiliados) no recargan la página: hay que cerrar el menú a mano.
    drawer.querySelectorAll('a[href*="#"]').forEach(function (el) {
      el.addEventListener('click', cerrar);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('hmov-drawer-abierto')) cerrar();
    });

    var panel = drawer.querySelector('.hmov-drawer-panel');
    if (panel) {
      var ladoDerecha = drawer.classList.contains('hmov-drawer-lado-derecha');
      var tocando = false;
      var inicioX = 0;
      var inicioY = 0;
      var deltaX = 0;
      var ejeDecidido = false;
      var esHorizontal = false;

      panel.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        tocando = true;
        ejeDecidido = false;
        esHorizontal = false;
        inicioX = e.touches[0].clientX;
        inicioY = e.touches[0].clientY;
        deltaX = 0;
      }, { passive: true });

      panel.addEventListener('touchmove', function (e) {
        if (!tocando) return;
        var x = e.touches[0].clientX;
        var y = e.touches[0].clientY;
        var dx = x - inicioX;
        var dy = y - inicioY;

        if (!ejeDecidido) {
          if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
            ejeDecidido = true;
            esHorizontal = Math.abs(dx) > Math.abs(dy);
          } else {
            return;
          }
        }

        if (!esHorizontal) return;

        var arrastreValido = ladoDerecha ? dx > 0 : dx < 0;
        if (arrastreValido) {
          deltaX = dx;
          panel.classList.add('hmov-drawer-arrastrando');
          panel.style.transform = 'translateX(' + dx + 'px)';
        }
      }, { passive: true });

      function finTouch() {
        if (!tocando) return;
        tocando = false;
        panel.classList.remove('hmov-drawer-arrastrando');
        panel.style.transform = '';
        var umbral = panel.offsetWidth * 0.3;
        if (esHorizontal && Math.abs(deltaX) > umbral) {
          cerrar();
        }
        deltaX = 0;
      }

      panel.addEventListener('touchend', finTouch);
      panel.addEventListener('touchcancel', finTouch);
    }
  }

  function initCarrito(header) {
    var contador = header.querySelector('[data-hmov-carrito-contador]');
    if (!contador) return;

    var ultimoCount = parseInt(contador.textContent, 10) || 0;

    function actualizar(count, esAdicion) {
      contador.textContent = count;
      if (parseInt(count, 10) > 0) {
        contador.removeAttribute('data-vacio');
      } else {
        contador.setAttribute('data-vacio', 'true');
      }

      if (esAdicion) {
        contador.classList.remove('hmov-badge-active');
        void contador.offsetWidth;
        contador.classList.add('hmov-badge-active');
        contador.classList.add('hmov-badge-anadido');

        setTimeout(function () {
          contador.classList.remove('hmov-badge-active');
        }, 700);

        setTimeout(function () {
          contador.classList.remove('hmov-badge-anadido');
        }, 2000);
      }

      ultimoCount = parseInt(count, 10) || 0;
    }

    actualizar(ultimoCount, false);

    function refresh(esAdicion) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var nuevo = data.item_count;
          var esAumento = nuevo > ultimoCount;
          actualizar(nuevo, esAdicion === true && esAumento);
        })
        .catch(function () {});
    }

    document.addEventListener('cart:updated', function (e) {
      if (e.detail && typeof e.detail.item_count !== 'undefined') {
        var nuevo = e.detail.item_count;
        var esAumento = nuevo > ultimoCount;
        actualizar(nuevo, esAumento);
      } else {
        refresh(true);
      }
    });

    document.addEventListener('product:added', function () { refresh(true); });
    document.addEventListener('cart:added', function () { refresh(true); });
    document.addEventListener('variant:added', function () { refresh(true); });

    document.body.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        setTimeout(function () { refresh(true); }, 600);
      }
    }, true);

    var origFetch = window.fetch;
    if (origFetch && !window.__hmovCartFetchHooked) {
      window.__hmovCartFetchHooked = true;
      window.fetch = function () {
        var url = arguments[0];
        var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
        var esCartAdd = urlStr.indexOf('/cart/add') !== -1;
        var resultado = origFetch.apply(this, arguments);
        if (esCartAdd) {
          resultado.then(function () {
            setTimeout(function () {
              document.querySelectorAll('[data-hmov-header]').forEach(function (h) {
                var c = h.querySelector('[data-hmov-carrito-contador]');
                if (c) {
                  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (data) {
                    var ev = new CustomEvent('cart:updated', { detail: { item_count: data.item_count } });
                    document.dispatchEvent(ev);
                  });
                }
              });
            }, 100);
          }).catch(function () {});
        }
        return resultado;
      };
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hmov-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target.querySelector('[data-hmov-header]');
    if (h) {
      h.dataset.hmovInit = '';
      initHeader(h);
    }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tomate-Preguntas-Frecuentes"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function cerrar(item) {
    var wrap = item.querySelector('[data-faq-respuesta]');
    var boton = item.querySelector('[data-faq-toggle]');
    item.classList.remove('faq-abierto');
    if (boton) boton.setAttribute('aria-expanded', 'false');
    if (wrap) {
      wrap.style.setProperty('max-height', '0px', 'important');
    }
  }

  function abrir(item) {
    var wrap = item.querySelector('[data-faq-respuesta]');
    var boton = item.querySelector('[data-faq-toggle]');
    item.classList.add('faq-abierto');
    if (boton) boton.setAttribute('aria-expanded', 'true');
    if (wrap) {
      wrap.style.setProperty('max-height', wrap.scrollHeight + 'px', 'important');
    }
  }

  function initFaq(seccion) {
    if (!seccion || seccion.dataset.faqInit === 'true') return;
    seccion.dataset.faqInit = 'true';

    var items = seccion.querySelectorAll('[data-faq-item]');

    items.forEach(function (item) {
      var boton = item.querySelector('[data-faq-toggle]');
      if (!boton) return;

      boton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var estaAbierto = item.classList.contains('faq-abierto');

        items.forEach(function (otro) {
          if (otro !== item) cerrar(otro);
        });

        if (estaAbierto) {
          cerrar(item);
        } else {
          abrir(item);
        }
      });
    });

    window.addEventListener('resize', function () {
      var abierto = seccion.querySelector('.faq-abierto');
      if (abierto) {
        var wrap = abierto.querySelector('[data-faq-respuesta]');
        if (wrap) {
          wrap.style.setProperty('max-height', wrap.scrollHeight + 'px', 'important');
        }
      }
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-faq-seccion]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = (e.target.matches && e.target.matches('[data-faq-seccion]'))
      ? e.target
      : e.target.querySelector && e.target.querySelector('[data-faq-seccion]');
    if (seccion) {
      delete seccion.dataset.faqInit;
      initFaq(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tomate-anuncios"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initBarra(barra) {
    if (barra.dataset.banInit === 'true') return;
    barra.dataset.banInit = 'true';

    var modo = barra.dataset.banModo;
    var velocidad = parseFloat(barra.dataset.banVelocidad) * 1000;

    if (barra.dataset.banAutoocultar === 'true') initScroll(barra);

    if (modo === 'rotativo') initRotativo(barra, velocidad);
    if (modo === 'ticker') initTicker(barra);
    if (barra.dataset.banZoom === 'true') initZoom(barra);
  }

  function initScroll(barra) {
    var lastY = 0;
    var oculta = false;
    var umbral = 80;
    var ticking = false;

    function actualizar() {
      var y = window.scrollY;
      var diff = y - lastY;

      if (y <= umbral) {
        if (oculta) { barra.classList.remove('ban-oculta'); oculta = false; }
      } else if (diff > 5 && !oculta) {
        barra.classList.add('ban-oculta'); oculta = true;
      } else if (diff < -5 && oculta) {
        barra.classList.remove('ban-oculta'); oculta = false;
      }

      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(actualizar);
        ticking = true;
      }
    }, { passive: true });
  }

  function initRotativo(barra, velocidad) {
    var slides = Array.from(barra.querySelectorAll('[data-ban-slide]'));
    if (!slides.length) return;

    var actual = 0;
    var animando = false;
    var intervalo = null;

    function mostrar(idx, direccion) {
      if (animando || idx === actual) return;
      animando = true;

      var saliente = slides[actual];
      var entrante = slides[idx];

      var xEntrada = direccion > 0 ? '100%' : '-100%';
      var xSalida  = direccion > 0 ? '-100%' : '100%';

      entrante.style.transition = 'none';
      entrante.style.transform = 'translateX(' + xEntrada + ')';
      entrante.style.opacity = '0';
      entrante.classList.add('ban-visible');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          saliente.style.transition = 'transform 0.5s ease, opacity 0.4s ease';
          saliente.style.transform = 'translateX(' + xSalida + ')';
          saliente.style.opacity = '0';

          entrante.style.transition = 'transform 0.5s ease, opacity 0.4s ease';
          entrante.style.transform = 'translateX(0)';
          entrante.style.opacity = '1';

          setTimeout(function () {
            saliente.classList.remove('ban-visible');
            saliente.style.transition = '';
            saliente.style.transform = '';
            saliente.style.opacity = '';
            entrante.style.transition = '';
            actual = idx;
            animando = false;
          }, 520);
        });
      });
    }

    slides[0].classList.add('ban-visible');
    slides[0].style.opacity = '1';
    slides[0].style.transform = 'translateX(0)';

    function avanzar() {
      var siguiente = (actual + 1) % slides.length;
      mostrar(siguiente, 1);
    }

    function arrancarIntervalo() {
      if (slides.length < 2) return;
      intervalo = setInterval(avanzar, velocidad);
    }

    function pararIntervalo() {
      clearInterval(intervalo);
    }

    arrancarIntervalo();
    barra.addEventListener('mouseenter', pararIntervalo);
    barra.addEventListener('mouseleave', arrancarIntervalo);
  }

  function initTicker(barra) {
    var track = barra.querySelector('[data-ban-ticker]');
    if (!track) return;

    var items = Array.from(track.querySelectorAll('.ban-ticker-item'));
    if (!items.length) return;

    items.forEach(function (item) {
      var c = item.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      var links = c.querySelectorAll('a');
      links.forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      track.appendChild(c);
    });

    requestAnimationFrame(function () {
      track.classList.add('ban-ticker-animando');
    });
  }

  function initZoom(barra) {
    var activacion = barra.dataset.banActivacion;
    var esMovil = function () { return window.matchMedia('(max-width: 749px)').matches; };
    var zoomMovil = barra.dataset.banZoomMovil === 'true';

    function abrir() {
      if (esMovil() && !zoomMovil) return;
      barra.classList.add('ban-abierta');
    }

    function cerrar() {
      barra.classList.remove('ban-abierta');
    }

    function toggle() {
      if (esMovil() && !zoomMovil) return;
      if (barra.classList.contains('ban-abierta')) cerrar();
      else abrir();
    }

    if (activacion === 'hover') {
      barra.addEventListener('mouseenter', abrir);
      barra.addEventListener('mouseleave', cerrar);
    } else if (activacion === 'click') {
      barra.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        toggle();
      });
      document.addEventListener('click', function (e) {
        if (!barra.contains(e.target) && barra.classList.contains('ban-abierta')) {
          cerrar();
        }
      });
    } else if (activacion === 'mixto') {
      if (esMovil()) {
        barra.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;
          toggle();
        });
        document.addEventListener('click', function (e) {
          if (!barra.contains(e.target) && barra.classList.contains('ban-abierta')) {
            cerrar();
          }
        });
      } else {
        barra.addEventListener('mouseenter', abrir);
        barra.addEventListener('mouseleave', cerrar);
      }
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && barra.classList.contains('ban-abierta')) cerrar();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ban-barra]').forEach(initBarra);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var barra = e.target.querySelector('[data-ban-barra]');
    if (barra) {
      barra.dataset.banInit = '';
      initBarra(barra);
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var barra = e.target.closest('[data-ban-barra]');
    if (!barra || barra.dataset.banModo !== 'rotativo') return;
    var slides = Array.from(barra.querySelectorAll('[data-ban-slide]'));
    var idx = slides.indexOf(e.target);
    if (idx < 0) return;
    slides.forEach(function (s, i) {
      s.classList.toggle('ban-visible', i === idx);
      if (i === idx) {
        s.style.opacity = '1';
        s.style.transform = 'translateX(0)';
      } else {
        s.style.opacity = '';
        s.style.transform = '';
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tomate-footer2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFmdFooter(footer) {
    if (!footer || footer.dataset.fmdInit === 'true') return;
    footer.dataset.fmdInit = 'true';

    var desplegables = footer.querySelectorAll('[data-fmd-desplegable]');
    if (!desplegables.length) return;

    desplegables.forEach(function (det) {
      var summary = det.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function () {
        var estaAbierto = det.hasAttribute('open');
        if (!estaAbierto) {
          desplegables.forEach(function (otro) {
            if (otro !== det && otro.hasAttribute('open')) {
              otro.removeAttribute('open');
            }
          });
        }
      });
    });

    document.addEventListener('click', function (e) {
      desplegables.forEach(function (det) {
        if (det.hasAttribute('open') && !det.contains(e.target)) {
          det.removeAttribute('open');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        desplegables.forEach(function (det) {
          if (det.hasAttribute('open')) {
            det.removeAttribute('open');
          }
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fmd-footer]').forEach(initFmdFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var footer = e.target.querySelector('[data-fmd-footer]');
    if (footer) initFmdFooter(footer);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tomate-heropro"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function detectarNumeros(texto) {
    var regex = /(\d+(?:[,.]\d+)?)/g;
    var matches = [];
    var m;
    while ((m = regex.exec(texto)) !== null) {
      var raw = m[1];
      var decimales = 0;
      var sep = '';
      if (raw.indexOf(',') >= 0) { sep = ','; decimales = raw.split(',')[1].length; }
      else if (raw.indexOf('.') >= 0) { sep = '.'; decimales = raw.split('.')[1].length; }
      matches.push({
        raw: raw,
        valor: parseFloat(raw.replace(',', '.')),
        decimales: decimales,
        sep: sep,
        inicio: m.index,
        fin: m.index + raw.length
      });
    }
    return matches;
  }

  function formatearNumero(valor, decimales, sep) {
    if (decimales === 0) {
      return Math.round(valor).toString();
    }
    var formateado = valor.toFixed(decimales);
    if (sep === ',') {
      formateado = formateado.replace('.', ',');
    }
    return formateado;
  }

  function setupContador(elemento, duracion) {
    if (elemento.dataset.hmdContadorInit === 'true') return;
    elemento.dataset.hmdContadorInit = 'true';

    var textoOriginal = elemento.textContent.trim();
    var matches = detectarNumeros(textoOriginal);
    if (matches.length === 0) return;

    function render(progreso) {
      var resultado = '';
      var ultimo = 0;
      for (var i = 0; i < matches.length; i++) {
        var n = matches[i];
        resultado += textoOriginal.substring(ultimo, n.inicio);
        var val = n.valor * progreso;
        resultado += formatearNumero(val, n.decimales, n.sep);
        ultimo = n.fin;
      }
      resultado += textoOriginal.substring(ultimo);
      elemento.textContent = resultado;
    }

    render(0);

    var inicio = null;
    function paso(now) {
      if (inicio === null) inicio = now;
      var transcurrido = now - inicio;
      var progreso = Math.min(transcurrido / duracion, 1);
      var eased = easeOutCubic(progreso);
      render(eased);
      if (progreso < 1) {
        requestAnimationFrame(paso);
      } else {
        elemento.textContent = textoOriginal;
      }
    }
    requestAnimationFrame(paso);
  }

  function initSeccion(seccion) {
    if (seccion.dataset.hmdAnimInit === 'true') return;
    seccion.dataset.hmdAnimInit = 'true';

    var tipoAnim = '';
    seccion.classList.forEach(function (c) {
      if (c.indexOf('hmd-anim-') === 0 && c !== 'hmd-anim-visible' && c.indexOf('hmd-anim-seq-') !== 0) tipoAnim = c;
    });

    var contadorActivo = seccion.dataset.hmdContador === 'true';
    var estilos = getComputedStyle(seccion);
    var contadorDur = parseInt(estilos.getPropertyValue('--hmd-contador-dur')) || 2000;
    var animRetraso = parseInt(estilos.getPropertyValue('--hmd-anim-retraso')) || 0;
    var enSecuencia = seccion.classList.contains('hmd-anim-seq-secuencia');

    function dispararContador() {
      if (!contadorActivo) return;
      var delayStats = enSecuencia ? (5 * animRetraso) : 0;
      var statsNums = seccion.querySelectorAll('[data-hmd-stat-num]');
      setTimeout(function () {
        statsNums.forEach(function (el) {
          setupContador(el, contadorDur);
        });
      }, delayStats);
    }

    if (tipoAnim === 'hmd-anim-ninguna' || tipoAnim === '') {
      seccion.classList.add('hmd-anim-visible');
      dispararContador();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      seccion.classList.add('hmd-anim-visible');
      dispararContador();
      return;
    }

    var prefiereReducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefiereReducir) {
      seccion.classList.add('hmd-anim-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('hmd-anim-visible');
          dispararContador();
          observer.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    observer.observe(seccion);
  }

  function initAll() {
    document.querySelectorAll('[data-hmd-seccion]').forEach(initSeccion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = e.target.querySelector('[data-hmd-seccion]');
    if (seccion) {
      seccion.dataset.hmdAnimInit = '';
      var nums = seccion.querySelectorAll('[data-hmd-stat-num]');
      nums.forEach(function (n) { n.dataset.hmdContadorInit = ''; });
      initSeccion(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tomate-kit1"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var COLORES_HEX = {
    'blanco': '#ffffff',
    'negro': '#000000',
    'azul marino': '#0a1c3d',
    'azul': '#1c5dd9',
    'rojo': '#c0392b',
    'verde': '#27ae60',
    'amarillo': '#f1c40f',
    'gris': '#7f8c8d',
    'rosa': '#e91e63',
    'naranja': '#e67e22',
    'morado': '#8e44ad',
    'beige': '#d6c9a0',
    'marron': '#6b4423',
    'celeste': '#5dade2',
    'fucsia': '#c2185b'
  };

  function hexParaNombre(nombre) {
    var clave = (nombre || '').toLowerCase().trim();
    for (var k in COLORES_HEX) {
      if (clave.indexOf(k) !== -1) return COLORES_HEX[k];
    }
    return '#cccccc';
  }

  function formateoMoneda(valor) {
    return valor.toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function generarNumPresupuesto() {
    var d = new Date();
    var y = d.getFullYear().toString().slice(-2);
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var dia = String(d.getDate()).padStart(2, '0');
    var rnd = Math.floor(Math.random() * 9999).toString().padStart(4, '0');
    return y + m + dia + '-' + rnd;
  }

  function svgCamiseta(rect) {
    var path = 'M28 18 L40 8 L52 8 Q60 8 64 14 L80 22 L74 38 L68 34 L68 90 Q68 92 66 92 L34 92 Q32 92 32 90 L32 34 L26 38 L20 22 L28 18 Z';
    return '<svg class="pre-zona-icono" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="' + path + '" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linejoin="round"/>' +
      rect +
      '</svg>';
  }

  function svgManga(rect) {
    var path = 'M30 10 Q30 8 32 8 L68 8 Q70 8 70 10 L70 86 Q70 92 60 92 L40 92 Q30 92 30 86 Z';
    return '<svg class="pre-zona-icono" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="' + path + '" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linejoin="round"/>' +
      rect +
      '</svg>';
  }

  var ZONAS = [
    { id: 'pecho-peq-ctro', nombre: 'Pecho peq ctro', svg: svgCamiseta('<rect x="46" y="30" width="8" height="8" fill="currentColor"/>') },
    { id: 'pecho-peq-izq',  nombre: 'Pecho peq izq',  svg: svgCamiseta('<rect x="38" y="30" width="8" height="8" fill="currentColor"/>') },
    { id: 'pecho-peq-dcha', nombre: 'Pecho peq dcha', svg: svgCamiseta('<rect x="54" y="30" width="8" height="8" fill="currentColor"/>') },
    { id: 'pecho-mediano',  nombre: 'Pecho mediano',  svg: svgCamiseta('<rect x="42" y="28" width="16" height="16" fill="currentColor"/>') },
    { id: 'pecho-grande',   nombre: 'Pecho grande',   svg: svgCamiseta('<rect x="36" y="34" width="28" height="36" fill="currentColor"/>') },
    { id: 'espalda-peq',    nombre: 'Espalda pequeño', svg: svgCamiseta('<rect x="46" y="28" width="8" height="8" fill="currentColor"/>') },
    { id: 'espalda-mediano',nombre: 'Espalda mediano',svg: svgCamiseta('<rect x="42" y="26" width="16" height="16" fill="currentColor"/>') },
    { id: 'espalda-grande', nombre: 'Espalda grande', svg: svgCamiseta('<rect x="36" y="32" width="28" height="38" fill="currentColor"/>') },
    { id: 'm-izquierda',    nombre: 'M Izquierda',    svg: svgManga('<rect x="44" y="22" width="12" height="14" fill="currentColor"/>') },
    { id: 'm-derecha',      nombre: 'M Derecha',      svg: svgManga('<rect x="44" y="22" width="12" height="14" fill="currentColor"/>') }
  ];

  function renderizarZonasEnPanel(panel, tecnica) {
    if (panel.dataset.zonasRendered === 'true') return;
    panel.dataset.zonasRendered = 'true';

    var html = '';
    ZONAS.forEach(function (z) {
      var inputId = 'zona-' + tecnica + '-' + z.id + '-' + Math.random().toString(36).slice(2, 8);
      html += '<label class="pre-zona">' +
        z.svg +
        '<div class="pre-zona-pie">' +
          '<input type="checkbox" class="pre-zona-check" id="' + inputId + '" data-zona-id="' + z.id + '" data-tecnica="' + tecnica + '">' +
          '<span class="pre-zona-nombre">' + z.nombre + '</span>' +
        '</div>' +
      '</label>';
    });
    panel.innerHTML = html;
  }

  function initSeccion(seccion) {
    if (seccion.dataset.preInit === 'true') return;
    seccion.dataset.preInit = 'true';

    var select = seccion.querySelector('[data-pre-select]');
    var btnAnadir = seccion.querySelector('[data-pre-anadir]');
    var contenedorProductos = seccion.querySelector('[data-pre-productos]');
    var template = seccion.querySelector('[data-pre-template]');
    var mensajeVacio = seccion.querySelector('[data-pre-vacio]');
    var numPresupuesto = seccion.querySelector('[data-pre-num-presupuesto]');
    var stNProductos = seccion.querySelector('[data-pre-n-productos]');
    var stUnidad = seccion.querySelector('[data-pre-unidad]');
    var stTotal = seccion.querySelector('[data-pre-total]');
    var btnCarrito = seccion.querySelector('[data-pre-carrito]');

    if (numPresupuesto) numPresupuesto.textContent = generarNumPresupuesto();

    function obtenerProductoData(value) {
      if (!value) return null;
      var opt = select.querySelector('option[value="' + value + '"]');
      if (!opt) return null;
      return {
        id: value,
        handle: opt.getAttribute('data-handle') || '',
        titulo: opt.getAttribute('data-titulo') || opt.textContent.trim(),
        imagen: opt.getAttribute('data-imagen') || '',
        precio: parseInt(opt.getAttribute('data-precio'), 10) || 0
      };
    }

    function consultarVariantesShopify(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) { return data; })
        .catch(function () { return null; });
    }

    function extraerColoresYTallas(productoData) {
      var colores = [];
      var tallas = [];
      var matriz = {};
      var optColorIndex = -1;
      var optTallaIndex = -1;

      if (productoData.options) {
        productoData.options.forEach(function (op, i) {
          var nombre = (op.name || op).toLowerCase();
          if (nombre.indexOf('color') !== -1) optColorIndex = i;
          else if (nombre.indexOf('talla') !== -1 || nombre.indexOf('size') !== -1) optTallaIndex = i;
        });
      }

      if (optColorIndex === -1 && optTallaIndex === -1 && productoData.options && productoData.options.length >= 2) {
        optColorIndex = 0;
        optTallaIndex = 1;
      } else if (optColorIndex === -1 && optTallaIndex !== -1 && productoData.options.length >= 2) {
        optColorIndex = optTallaIndex === 0 ? 1 : 0;
      } else if (optTallaIndex === -1 && optColorIndex !== -1 && productoData.options.length >= 2) {
        optTallaIndex = optColorIndex === 0 ? 1 : 0;
      }

      (productoData.variants || []).forEach(function (v) {
        var c = optColorIndex >= 0 ? v['option' + (optColorIndex + 1)] : (v.title || '');
        var t = optTallaIndex >= 0 ? v['option' + (optTallaIndex + 1)] : '';

        if (c && colores.indexOf(c) === -1) colores.push(c);
        if (t && tallas.indexOf(t) === -1) tallas.push(t);

        if (c) {
          if (!matriz[c]) matriz[c] = {};
          matriz[c][t || '-'] = { id: v.id, precio: v.price, disponible: v.available };
        }
      });

      if (tallas.length === 0) tallas.push('Único');

      return { colores: colores, tallas: tallas, matriz: matriz };
    }

    function ordenarTallas(tallas) {
      var orden = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL', '6XL'];
      var conocidas = [], desconocidas = [];
      tallas.forEach(function (t) {
        var idx = orden.indexOf(t.toUpperCase());
        if (idx !== -1) conocidas.push({ talla: t, peso: idx });
        else desconocidas.push(t);
      });
      conocidas.sort(function (a, b) { return a.peso - b.peso; });
      return conocidas.map(function (x) { return x.talla; }).concat(desconocidas);
    }

    function renderizarTabla(producto, colores, tallas, matriz) {
      var tablaEl = producto.querySelector('[data-pre-tabla]');
      if (!tablaEl) return;
      tablaEl.innerHTML = '';

      tallas = ordenarTallas(tallas);

      colores.forEach(function (color) {
        var fila = document.createElement('div');
        fila.className = 'pre-fila-color';

        var info = document.createElement('div');
        info.className = 'pre-color-info';

        var muestra = document.createElement('div');
        muestra.className = 'pre-color-muestra';
        muestra.style.backgroundColor = hexParaNombre(color);

        var nombre = document.createElement('div');
        nombre.className = 'pre-color-nombre';
        nombre.textContent = color;

        info.appendChild(muestra);
        info.appendChild(nombre);

        var tallasWrap = document.createElement('div');
        tallasWrap.className = 'pre-tallas';

        tallas.forEach(function (t) {
          var contTalla = document.createElement('div');
          contTalla.className = 'pre-talla';

          var label = document.createElement('div');
          label.className = 'pre-talla-label';
          label.textContent = t;

          var input = document.createElement('input');
          input.type = 'number';
          input.className = 'pre-talla-input';
          input.min = '0';
          input.value = '';
          input.placeholder = '';
          input.dataset.color = color;
          input.dataset.talla = t;
          input.dataset.variantId = (matriz[color] && matriz[color][t]) ? matriz[color][t].id : '';
          input.dataset.precio = (matriz[color] && matriz[color][t]) ? matriz[color][t].precio : '0';

          input.addEventListener('input', recalcular);

          contTalla.appendChild(label);
          contTalla.appendChild(input);
          tallasWrap.appendChild(contTalla);
        });

        fila.appendChild(info);
        fila.appendChild(tallasWrap);
        tablaEl.appendChild(fila);
      });
    }

    function actualizarVisibilidadVacio() {
      var hayProductos = contenedorProductos.querySelectorAll('[data-pre-producto]').length > 0;
      if (mensajeVacio) {
        if (hayProductos) mensajeVacio.classList.add('pre-oculto');
        else mensajeVacio.classList.remove('pre-oculto');
      }
    }

    function recalcular() {
      var inputs = contenedorProductos.querySelectorAll('.pre-talla-input');
      var totalUnidades = 0;
      var totalPrecio = 0;

      inputs.forEach(function (inp) {
        var v = parseInt(inp.value, 10) || 0;
        var precio = parseInt(inp.dataset.precio, 10) || 0;
        totalUnidades += v;
        totalPrecio += v * precio;
      });

      var totalEuros = totalPrecio / 100;
      var unidad = totalUnidades > 0 ? totalEuros / totalUnidades : 0;

      if (stNProductos) stNProductos.textContent = totalUnidades;
      if (stUnidad) stUnidad.textContent = formateoMoneda(unidad);
      if (stTotal) stTotal.textContent = formateoMoneda(totalEuros);
    }

    function activarPestana(producto, panelId) {
      producto.querySelectorAll('[data-pre-pestana]').forEach(function (b) {
        if (b.getAttribute('data-pre-pestana') === panelId) b.classList.add('pre-pestana-activa');
        else b.classList.remove('pre-pestana-activa');
      });
      producto.querySelectorAll('[data-pre-panel]').forEach(function (p) {
        if (p.getAttribute('data-pre-panel') === panelId) {
          p.removeAttribute('hidden');
          var zonasEl = p.querySelector('[data-pre-zonas]');
          if (zonasEl) renderizarZonasEnPanel(zonasEl, panelId);
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    function anadirProducto() {
      var value = select.value;
      if (!value) return;
      var data = obtenerProductoData(value);
      if (!data) return;

      var fragment = template.content.cloneNode(true);
      var producto = fragment.querySelector('[data-pre-producto]');

      producto.querySelector('[data-pre-nombre]').textContent = data.titulo;
      var img = producto.querySelector('[data-pre-imagen]');
      if (img && data.imagen) {
        img.src = data.imagen;
        img.alt = data.titulo;
      }

      producto.querySelector('[data-pre-quitar]').addEventListener('click', function () {
        producto.remove();
        actualizarVisibilidadVacio();
        recalcular();
      });

      producto.querySelectorAll('[data-pre-pestana]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          activarPestana(producto, btn.getAttribute('data-pre-pestana'));
        });
      });

      contenedorProductos.appendChild(producto);
      actualizarVisibilidadVacio();

      consultarVariantesShopify(data.handle).then(function (datos) {
        if (!datos) {
          renderizarTabla(producto, ['—'], ['Única'], {});
          return;
        }
        var extra = extraerColoresYTallas(datos);
        renderizarTabla(producto, extra.colores, extra.tallas, extra.matriz);
      });

      select.value = '';
    }

    if (btnAnadir) {
      btnAnadir.addEventListener('click', anadirProducto);
    }

    if (btnCarrito) {
      btnCarrito.addEventListener('click', function () {
        var inputs = contenedorProductos.querySelectorAll('.pre-talla-input');
        var items = [];
        inputs.forEach(function (inp) {
          var v = parseInt(inp.value, 10) || 0;
          var vid = inp.dataset.variantId;
          if (v > 0 && vid) {
            items.push({ id: parseInt(vid, 10), quantity: v });
          }
        });

        if (items.length === 0) {
          alert('No has seleccionado ninguna cantidad.');
          return;
        }

        btnCarrito.disabled = true;
        var textoOriginal = btnCarrito.querySelector('span').textContent;
        btnCarrito.querySelector('span').textContent = 'Anadiendo...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('err');
          return r.json();
        }).then(function () {
          btnCarrito.querySelector('span').textContent = 'Anadido al carrito';
          var ev = new CustomEvent('cart:updated');
          document.dispatchEvent(ev);
          setTimeout(function () {
            btnCarrito.disabled = false;
            btnCarrito.querySelector('span').textContent = textoOriginal;
          }, 1800);
        }).catch(function () {
          btnCarrito.querySelector('span').textContent = 'Error';
          setTimeout(function () {
            btnCarrito.disabled = false;
            btnCarrito.querySelector('span').textContent = textoOriginal;
          }, 2200);
        });
      });
    }

    actualizarVisibilidadVacio();
  }

  function initAll() {
    document.querySelectorAll('[id^="presup-"]').forEach(initSeccion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[id^="presup-"]');
    if (s) {
      s.dataset.preInit = '';
      initSeccion(s);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tomate-producto-destacado-01"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function dispararCartUpdated() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (data) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: data.item_count } }));
    }).catch(function () {});
  }

  function initBoton(boton) {
    if (boton.dataset.destInit === 'true') return;
    boton.dataset.destInit = 'true';

    boton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variant = boton.getAttribute('data-variant');
      if (!variant) return;

      var textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = 'Anadiendo...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variant, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('err');
        return r.json();
      }).then(function () {
        boton.classList.add('dest-boton-ok');
        boton.textContent = 'Anadido';
        dispararCartUpdated();
        setTimeout(function () {
          boton.disabled = false;
          boton.classList.remove('dest-boton-ok');
          boton.textContent = textoOriginal;
        }, 1600);
      }).catch(function () {
        boton.textContent = 'Error';
        setTimeout(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
        }, 2000);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-dest-add]').forEach(initBoton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-dest]')) initAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel-md"] && !Shopify.designMode) return;
  try {
    

(function () {

  'use strict';



  function easeOutCubic(t) {

    return 1 - Math.pow(1 - t, 3);

  }



  function detectarNumeros(texto) {

    var regex = /(\d+(?:[,.]\d+)?)/g;

    var matches = [];

    var m;

    while ((m = regex.exec(texto)) !== null) {

      var raw = m[1];

      var decimales = 0;

      var sep = '';

      if (raw.indexOf(',') >= 0) { sep = ','; decimales = raw.split(',')[1].length; }

      else if (raw.indexOf('.') >= 0) { sep = '.'; decimales = raw.split('.')[1].length; }

      matches.push({ raw: raw, valor: parseFloat(raw.replace(',', '.')), decimales: decimales, sep: sep, inicio: m.index, fin: m.index + raw.length });

    }

    return matches;

  }



  function formatearNumero(valor, decimales, sep) {

    if (decimales === 0) { return Math.round(valor).toString(); }

    var formateado = valor.toFixed(decimales);

    if (sep === ',') { formateado = formateado.replace('.', ','); }

    return formateado;

  }



  function setupContador(elemento, duracion) {

    if (elemento.dataset.hmdContadorInit === 'true') return;

    elemento.dataset.hmdContadorInit = 'true';

    var textoOriginal = elemento.textContent.trim();

    var matches = detectarNumeros(textoOriginal);

    if (matches.length === 0) return;

    function render(progreso) {

      var resultado = '';

      var ultimo = 0;

      for (var i = 0; i < matches.length; i++) {

        var n = matches[i];

        resultado += textoOriginal.substring(ultimo, n.inicio);

        resultado += formatearNumero(n.valor * progreso, n.decimales, n.sep);

        ultimo = n.fin;

      }

      resultado += textoOriginal.substring(ultimo);

      elemento.textContent = resultado;

    }

    render(0);

    var inicio = null;

    function paso(now) {

      if (inicio === null) inicio = now;

      var progreso = Math.min((now - inicio) / duracion, 1);

      render(easeOutCubic(progreso));

      if (progreso < 1) { requestAnimationFrame(paso); } else { elemento.textContent = textoOriginal; }

    }

    requestAnimationFrame(paso);

  }



  function initBanner(banner) {

    if (banner.dataset.hmdAnimInit === 'true') return;

    banner.dataset.hmdAnimInit = 'true';

    var tipoAnim = '';

    banner.classList.forEach(function (c) {

      if (c.indexOf('hmd-anim-') === 0 && c !== 'hmd-anim-visible' && c.indexOf('hmd-anim-seq-') !== 0) tipoAnim = c;

    });

    var contadorActivo = banner.dataset.hmdContador === 'true';

    var estilos = getComputedStyle(banner);

    var contadorDur = parseInt(estilos.getPropertyValue('--hmd-contador-dur')) || 2000;

    var animRetraso = parseInt(estilos.getPropertyValue('--hmd-anim-retraso')) || 0;

    var enSecuencia = banner.classList.contains('hmd-anim-seq-secuencia');

    function dispararContador() {

      if (!contadorActivo) return;

      var delayStats = enSecuencia ? (5 * animRetraso) : 0;

      var statsNums = banner.querySelectorAll('[data-hmd-stat-num]');

      setTimeout(function () { statsNums.forEach(function (el) { setupContador(el, contadorDur); }); }, delayStats);

    }

    /* La foto del banner nunca anima entrada en móvil: la pinamos visible

       desde el primer frame para que el estado inicial opacity:0 de la

       animación no llegue a verse mientras el observer no ha disparado. */

    var pinFotoMovil = function () {

      var enMovil = window.matchMedia && window.matchMedia('(max-width: 989px)').matches;

      var imgZona = banner.querySelector('.hmd-imagen-zona.hmd-anim-elem');

      if (!imgZona) return;

      if (enMovil) {

        imgZona.style.opacity = '1';

        imgZona.style.transform = 'none';

        imgZona.style.transition = 'none';

      } else {

        imgZona.style.opacity = '';

        imgZona.style.transform = '';

        imgZona.style.transition = '';

      }

    };

    pinFotoMovil();

    if (window.matchMedia) {

      window.matchMedia('(max-width: 989px)').addEventListener('change', pinFotoMovil);

    }

    if (window.Shopify && window.Shopify.designMode) { banner.classList.add('hmd-anim-visible'); dispararContador(); return; }

    if (tipoAnim === 'hmd-anim-ninguna' || tipoAnim === '') { banner.classList.add('hmd-anim-visible'); dispararContador(); return; }

    if (!('IntersectionObserver' in window)) { banner.classList.add('hmd-anim-visible'); dispararContador(); return; }

    var prefiereReducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefiereReducir) { banner.classList.add('hmd-anim-visible'); dispararContador(); return; }

    var observer = new IntersectionObserver(function (entradas) {

      entradas.forEach(function (entrada) {

        if (entrada.isIntersecting) { entrada.target.classList.add('hmd-anim-visible'); dispararContador(); observer.unobserve(entrada.target); }

      });

    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    observer.observe(banner);

  }



  /* ===== Carrusel ===== */

  function Carrusel(root) {

    this.root = root;

    this.track = root.querySelector('[data-hmd-track]');

    if (this.track) {

      var clonesPrevios = this.track.querySelectorAll('[data-hmd-clon]');

      for (var c = 0; c < clonesPrevios.length; c++) clonesPrevios[c].remove();

      this.track.style.transform = '';

    }

    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hmd-slide]:not([data-hmd-clon])'));

    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hmd-dot]'));

    this.prevBtn = root.querySelector('[data-hmd-prev]');

    this.nextBtn = root.querySelector('[data-hmd-next]');

    this.total = this.slides.length;

    this.index = 0;

    this.transicion = root.dataset.hmdTransicion || 'slide';

    this.autoplay = root.dataset.hmdAutoplay === 'true';

    this.velocidad = parseInt(root.dataset.hmdAutoplayVelocidad, 10) || 5000;

    this.viewport = root.querySelector('[data-hmd-viewport]');

    this.timer = null;

    this.reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.init();

  }



  Carrusel.prototype.usaLoop = function () { return this.transicion === 'slide' && this.total > 1; };

  Carrusel.prototype.estaEnClon = function () { return this.usaLoop() && (this.vi === 0 || this.vi === this.total + 1); };

  Carrusel.prototype.medirGap = function () {

    if (!this.track) return 0;

    var g = getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || '0px';

    var n = parseFloat(g);

    return isNaN(n) ? 0 : n;

  };



  Carrusel.prototype.montarClones = function () {

    if (!this.track || this.total < 2) return;

    var sobrantes = this.track.querySelectorAll('[data-hmd-clon]');

    for (var s = 0; s < sobrantes.length; s++) sobrantes[s].remove();

    var primero = this.slides[0];

    var ultimo = this.slides[this.total - 1];

    this.cloneInicio = ultimo.cloneNode(true);

    this.cloneFin = primero.cloneNode(true);

    [this.cloneInicio, this.cloneFin].forEach(function (c) {

      c.classList.remove('is-activo');

      c.setAttribute('aria-hidden', 'true');

      c.setAttribute('inert', '');

      c.setAttribute('data-hmd-clon', 'true');

      c.removeAttribute('id');

      c.classList.add('hmd-anim-visible');

      var animElems = c.querySelectorAll('.hmd-anim-elem');

      for (var ae = 0; ae < animElems.length; ae++) {

        animElems[ae].style.opacity = '1';

        animElems[ae].style.transform = 'none';

        animElems[ae].style.transition = 'none';

      }

    });

    this.track.insertBefore(this.cloneInicio, primero);

    this.track.appendChild(this.cloneFin);

    /* Los vídeos clonados tienen attribute autoplay y preload="auto". Aunque

       hacemos pause() después, el navegador ya inicia su descarga y compite

       con los vídeos originales por ancho de banda y por slots de decode de

       vídeo. En carruseles con varios slides con vídeo, esto es la causa más

       habitual de que algunos vídeos no arranquen. Los clones se ven sólo

       durante la transición de loop, así que les quitamos autoplay/preload. */

    var clonVids = this.track.querySelectorAll('[data-hmd-clon] .hmd-capa-video');

    for (var cv = 0; cv < clonVids.length; cv++) {

      var cVid = clonVids[cv];

      cVid.removeAttribute('autoplay');

      cVid.removeAttribute('loop');

      cVid.preload = 'none';

      pausarVideo(cVid);

    }

    this.vi = this.index + 1;

    this.track.addEventListener('transitionend', this._onTransEnd);

  };



  Carrusel.prototype.anchoContenido = function () {

    if (!this.viewport) return 0;

    var cs = getComputedStyle(this.viewport);

    return this.viewport.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);

  };



  Carrusel.prototype.pasoPx = function () {

    if (!this.track) return 0;

    var hijos = this.track.children;

    if (hijos.length >= 2) {

      var paso = hijos[1].offsetLeft - hijos[0].offsetLeft;

      if (paso > 0) return paso;

    }

    if (!this.slides.length) return 0;

    var ancho = this.slides[0].getBoundingClientRect().width;

    if (!(ancho > 0)) ancho = this.anchoContenido();

    return ancho + this.medirGap();

  };



  Carrusel.prototype.translatePxLoop = function (vi) { return -(vi * this.pasoPx()); };



  Carrusel.prototype.medirAltura = function () {

    if (!this.track || !this.slides.length) return;



    /* En móvil el alto lo da el contenido — no tocamos nada */

    if (window.innerWidth <= 989) {

      this.track.style.removeProperty('--hmd-car-altura');

      this.root.removeAttribute('data-hmd-altura-fijada');

      return;

    }



    if (this.root.dataset.hmdAlturaFija === 'true') {

      return;

    }



    this.track.style.removeProperty('--hmd-car-altura');

    this.root.removeAttribute('data-hmd-altura-fijada');

    if (window.Shopify && window.Shopify.designMode) { return; }

    var esFade = this.transicion === 'fade';

    var maxAlto = 0;

    for (var i = 0; i < this.slides.length; i++) {

      var slide = this.slides[i];

      if (slide.hasAttribute('data-hmd-clon')) continue;

      var cont = slide.querySelector('.hmd-contenedor');

      if (!cont) continue;

      var restaurarSlide = null;

      if (esFade) {

        restaurarSlide = { position: slide.style.position, inset: slide.style.inset, height: slide.style.height, opacity: slide.style.opacity, pointerEvents: slide.style.pointerEvents };

        slide.style.position = 'static'; slide.style.inset = 'auto'; slide.style.height = 'auto';

        slide.style.opacity = '0'; slide.style.pointerEvents = 'none';

      }

      var prevContMinH = cont.style.minHeight;

      var prevContHeight = cont.style.height;

      var prevContOverflow = cont.style.overflow;

      cont.style.minHeight = '0px'; cont.style.height = 'auto'; cont.style.overflow = 'visible';

      var colTexto = cont.querySelector('.hmd-col-texto');

      var textoEl = cont.querySelector('.hmd-texto');

      var prevColJustify = colTexto ? colTexto.style.justifyContent : null;

      var prevTextoJustify = textoEl ? textoEl.style.justifyContent : null;

      if (colTexto) colTexto.style.justifyContent = 'flex-start';

      if (textoEl) textoEl.style.justifyContent = 'flex-start';

      var h = Math.ceil(cont.getBoundingClientRect().height);

      cont.style.minHeight = prevContMinH; cont.style.height = prevContHeight; cont.style.overflow = prevContOverflow;

      if (colTexto) colTexto.style.justifyContent = prevColJustify || '';

      if (textoEl) textoEl.style.justifyContent = prevTextoJustify || '';

      if (h > maxAlto) maxAlto = h;

      if (restaurarSlide) {

        slide.style.position = restaurarSlide.position; slide.style.inset = restaurarSlide.inset;

        slide.style.height = restaurarSlide.height; slide.style.opacity = restaurarSlide.opacity;

        slide.style.pointerEvents = restaurarSlide.pointerEvents;

      }

    }

    if (maxAlto > 0) {

      this.track.style.setProperty('--hmd-car-altura', maxAlto + 'px');

      this.root.setAttribute('data-hmd-altura-fijada', 'true');

    }

  };



  Carrusel.prototype.init = function () {

    var self = this;

    this._onTransEnd = function (e) {

      if (e.target !== self.track) return;

      if (e.propertyName && e.propertyName !== 'transform') return;

      self.normalizarBorde();

    };

    if (this.total <= 1) {

      this.aplicar(0, true);

      this.medirAltura();

      requestAnimationFrame(function () { self.medirAltura(); });

      var imgs1 = this.track ? this.track.querySelectorAll('img') : [];

      for (var k = 0; k < imgs1.length; k++) {

        if (!imgs1[k].complete) { imgs1[k].addEventListener('load', function () { self.medirAltura(); }, { once: true }); }

      }

      if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {

        document.fonts.ready.then(function () { self.medirAltura(); });

      }

      if (this.viewport && 'ResizeObserver' in window) {

        this._ultimoAncho = Math.round(this.viewport.clientWidth);

        this._ro = new ResizeObserver(function () {

          var a = Math.round(self.viewport.clientWidth);

          if (a === self._ultimoAncho) return;

          self._ultimoAncho = a; self.medirAltura();

        });

        this._ro.observe(this.viewport);

      }

      return;

    }

    if (this.usaLoop()) this.montarClones();

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.ir(self.index - 1); self.reiniciarAutoplay(); });

    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.ir(self.index + 1); self.reiniciarAutoplay(); });

    this.dots.forEach(function (dot) {

      dot.addEventListener('click', function () { self.ir(parseInt(dot.dataset.hmdGoto, 10) || 0); self.reiniciarAutoplay(); });

    });

    this.bindSwipe();

    this._onVisibilidad = function () {

      if (document.hidden) { self.pararAutoplay(); }

      else { clearTimeout(self._normTimer); self.aplicar(self.index, true); self.iniciarAutoplay(); }

    };

    document.addEventListener('visibilitychange', this._onVisibilidad);

    this.recolocar = function () {

      self.medirAltura();

      if (!self.usaLoop()) return;

      self.aplicar(self.index, true);

    };

    this._onResize = function () { clearTimeout(self._resizeTimer); self._resizeTimer = setTimeout(self.recolocar, 120); };

    window.addEventListener('resize', this._onResize);

    window.addEventListener('orientationchange', this._onResize);

    if (this.viewport && 'ResizeObserver' in window) {

      this._ultimoAncho = Math.round(this.viewport.clientWidth);

      this._ro = new ResizeObserver(function () {

        var anchoActual = Math.round(self.viewport.clientWidth);

        if (anchoActual === self._ultimoAncho) return;

        self._ultimoAncho = anchoActual; self.recolocar();

      });

      this._ro.observe(this.viewport);

    }

    this.medirAltura();

    this.aplicar(0, true);

    requestAnimationFrame(function () { self.recolocar(); });

    setTimeout(function () { self.recolocar(); }, 300);

    setTimeout(function () { self.recolocar(); }, 600);

    var imgs = this.track ? this.track.querySelectorAll('img') : [];

    for (var im = 0; im < imgs.length; im++) {

      if (!imgs[im].complete) {

        imgs[im].addEventListener('load', this.recolocar, { once: true });

        imgs[im].addEventListener('error', this.recolocar, { once: true });

      }

    }

    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {

      document.fonts.ready.then(function () { self.recolocar(); });

    }

    this.iniciarAutoplay();

    /* Marcar como listo para que los cambios de slide

       retroalimenten las animaciones y los vídeos */

    setTimeout(function () { self._inicializado = true; }, 600);

  };



  Carrusel.prototype.destruir = function () {

    this._inicializado = false;

    if (this._ro) { try { this._ro.disconnect(); } catch (e) {} this._ro = null; }

    if (this._onResize) { window.removeEventListener('resize', this._onResize); window.removeEventListener('orientationchange', this._onResize); }

    if (this._onVisibilidad) { document.removeEventListener('visibilitychange', this._onVisibilidad); this._onVisibilidad = null; }

    clearTimeout(this._resizeTimer); clearTimeout(this._normTimer);

    this.pararAutoplay();

    if (this.track && this._onTransEnd) { this.track.removeEventListener('transitionend', this._onTransEnd); }

    if (this.track) {

      var clones = this.track.querySelectorAll('[data-hmd-clon]');

      for (var c = 0; c < clones.length; c++) clones[c].remove();

    }

  };



  Carrusel.prototype.ir = function (destino) {

    if (this.usaLoop()) {

      if (this.estaEnClon()) { this.normalizarBorde(); }

      this.aplicar(destino, false);

      return;

    }

    var n = destino;

    if (n < 0) n = this.total - 1;

    if (n >= this.total) n = 0;

    this.aplicar(n, false);

  };



  Carrusel.prototype.normalizarBorde = function () {

    if (!this.usaLoop()) return;

    if (this.vi === 0 || this.vi === this.total + 1) {

      var destino = (this.vi === 0) ? this.total - 1 : 0;

      this.aplicar(destino, true);

    }

  };



  Carrusel.prototype.aplicar = function (n, instant) {

    if (this.usaLoop()) {

      var real = ((n % this.total) + this.total) % this.total;

      if (n === -1) this.vi = 0;

      else if (n === this.total) this.vi = this.total + 1;

      else this.vi = real + 1;

      this.index = real;

      clearTimeout(this._normTimer);

      if (this.track) {

        var px = this.translatePxLoop(this.vi);

        if (instant) {

          this.track.style.transition = 'none';

          this.track.style.transform = 'translateX(' + px + 'px)';

          void this.track.offsetWidth;

          this.track.style.transition = '';

        } else {

          this.track.style.transition = '';

          this.track.style.transform = 'translateX(' + px + 'px)';

          if (this.vi === 0 || this.vi === this.total + 1) {

            var selfNorm = this;

            this._normTimer = setTimeout(function () { selfNorm.normalizarBorde(); }, 750);

          }

        }

      }

      this.marcarActivos(real);

      return;

    }

    this.index = n;

    if (this.transicion === 'slide' && this.track) {

      var transformPct = 'translateX(' + (-100 * n) + '%)';

      if (instant) {

        this.track.style.transition = 'none';

        this.track.style.transform = transformPct;

        void this.track.offsetWidth;

        this.track.style.transition = '';

      } else {

        this.track.style.transition = '';

        this.track.style.transform = transformPct;

      }

    }

    this.marcarActivos(n);

  };



  Carrusel.prototype.marcarActivos = function (n) {

    var self = this;

    for (var i = 0; i < this.slides.length; i++) {

      var activo = i === n;

      this.slides[i].classList.toggle('is-activo', activo);

      this.slides[i].setAttribute('aria-hidden', activo ? 'false' : 'true');
      if (activo) { this.slides[i].removeAttribute('inert'); } else { this.slides[i].setAttribute('inert', ''); }



      /* Vídeo: los vídeos NUNCA se pausan al desactivar el slide. Esto evita

         que el navegador bloquee el play() posterior por falta de user gesture.

         Al activar un slide sólo nos aseguramos de que esté reproduciéndose

         (sin reiniciar a 0, para no provocar re-buffering ni cortes). */

      var vid = this.slides[i].querySelector('.hmd-capa-video');

      if (vid && activo) {

        intentarPlayVideo(vid);

      }



      /* Retrigger de animación + contador: sólo después del arranque inicial.

         Al activar un slide: reset visual, reanima y re-dispara el contador de números.

         Al desactivar: reset (quedan ocultos para la próxima activación). */

      if (self._inicializado) {

        var banner = this.slides[i].querySelector('[data-hmd-banner]');

        if (banner) {

          banner.classList.remove('hmd-anim-visible');

          /* En móvil (<=989px) la foto nunca debe animar entrada. Fijamos sus

             estilos inline para que ni el frame de reset (rAF) entre quitar y

             re-añadir hmd-anim-visible la pueda ocultar. En desktop limpiamos

             los inline para devolver el control al CSS y permitir la animación. */

          var enMovil = window.matchMedia && window.matchMedia('(max-width: 989px)').matches;

          var imgZona = banner.querySelector('.hmd-imagen-zona.hmd-anim-elem');

          if (imgZona) {

            if (enMovil) {

              imgZona.style.opacity = '1';

              imgZona.style.transform = 'none';

              imgZona.style.transition = 'none';

            } else {

              imgZona.style.opacity = '';

              imgZona.style.transform = '';

              imgZona.style.transition = '';

            }

          }

          if (activo) {

            /* Resetear flags del contador para que pueda volver a animarse */

            var numsRetrigger = banner.querySelectorAll('[data-hmd-stat-num]');

            numsRetrigger.forEach(function (el) { el.dataset.hmdContadorInit = ''; });



            (function (b) {

              requestAnimationFrame(function () {

                requestAnimationFrame(function () {

                  b.classList.add('hmd-anim-visible');



                  /* Re-disparar contador animado si está activado */

                  if (b.dataset.hmdContador === 'true') {

                    var estilos = getComputedStyle(b);

                    var dur = parseInt(estilos.getPropertyValue('--hmd-contador-dur')) || 2000;

                    var retraso = parseInt(estilos.getPropertyValue('--hmd-anim-retraso')) || 0;

                    var enSeq = b.classList.contains('hmd-anim-seq-secuencia');

                    var delayContador = enSeq ? (5 * retraso) : 0;

                    var nums = b.querySelectorAll('[data-hmd-stat-num]');

                    setTimeout(function () {

                      nums.forEach(function (el) { setupContador(el, dur); });

                    }, delayContador);

                  }

                });

              });

            })(banner);

          }

        }

      }

    }

    for (var j = 0; j < this.dots.length; j++) {

      var dotActivo = j === n;

      this.dots[j].classList.toggle('is-activo', dotActivo);

      this.dots[j].setAttribute('aria-selected', dotActivo ? 'true' : 'false');

    }

  };



  Carrusel.prototype.iniciarAutoplay = function () {

    var self = this;

    if (!this.autoplay || this.reducir || this.total <= 1) return;

    if (document.hidden) return;

    this.pararAutoplay();

    this.timer = setInterval(function () { self.ir(self.index + 1); }, this.velocidad);

  };

  Carrusel.prototype.pararAutoplay = function () { if (this.timer) { clearInterval(this.timer); this.timer = null; } };

  Carrusel.prototype.reiniciarAutoplay = function () { this.pararAutoplay(); this.iniciarAutoplay(); };



  Carrusel.prototype.bindSwipe = function () {

    var self = this;

    var startX = 0, startY = 0, deltaX = 0, arrastrando = false;

    var viewport = this.root.querySelector('[data-hmd-viewport]');

    if (!viewport) return;

    viewport.addEventListener('touchstart', function (e) {

      if (e.touches.length !== 1) return;

      startX = e.touches[0].clientX; startY = e.touches[0].clientY;

      deltaX = 0; arrastrando = true; self.pararAutoplay();

    }, { passive: true });

    viewport.addEventListener('touchmove', function (e) {

      if (!arrastrando) return;

      deltaX = e.touches[0].clientX - startX;

      if (Math.abs(deltaX) < Math.abs(e.touches[0].clientY - startY)) { arrastrando = false; }

    }, { passive: true });

    viewport.addEventListener('touchend', function () {

      if (!arrastrando) { self.iniciarAutoplay(); return; }

      arrastrando = false;

      if (deltaX > 50) { self.ir(self.index - 1); }

      else if (deltaX < -50) { self.ir(self.index + 1); }

      self.iniciarAutoplay();

    });

  };



  Carrusel.prototype.mostrarSlide = function (n) {

    if (n < 0 || n >= this.total) return;

    if (this.usaLoop() && this.estaEnClon()) { this.normalizarBorde(); }

    this.aplicar(n, false);

    this.reiniciarAutoplay();

  };



  function initCarrusel(root) {

    if (!root) return;

    if (window.Shopify && window.Shopify.designMode) { root.classList.add('hmd-modo-editor'); }

    if (root.__hmdCarrusel) return root.__hmdCarrusel;

    var inst = new Carrusel(root);

    root.__hmdCarrusel = inst;

    return inst;

  }



  /* ===== Gestión robusta de vídeos de fondo =====

     Estrategia: cuando se pide reproducir un vídeo, intentar play(). Si falla,

     activar un interval que reintente cada segundo hasta que el vídeo se

     reproduzca o sea pausado explícitamente. Esto cubre:

     - Vídeos cuya descarga ha sido suspendida por el navegador.

     - Vídeos grandes que tardan más de los 32s del antiguo backoff.

     - Eventos canplay que no se disparan por congelación del decoder.

     Cada vídeo lleva una bandera `_hmdQuierePlay` que controla si el carrusel

     quiere que esté reproduciéndose, y un `_hmdRetryInterval` con el interval. */

  function intentarPlayVideo(v) {

    if (!v) return;

    /* Si el vídeo está oculto por CSS (p.ej. en móvil donde .hmd-capa-video
       es display:none permanente), no disparar la descarga de red. El ancho
       de banda reservado irá al LCP en su lugar. */
    if (getComputedStyle(v).display === 'none') return;

    v._hmdQuierePlay = true;

    /* Forzar muted SIEMPRE. Los navegadores sólo permiten autoplay sin user

       gesture si el vídeo está silenciado. Un vídeo de fondo decorativo nunca

       debe tener sonido, así que esto es seguro y garantiza la reproducción. */

    v.muted = true;

    v.defaultMuted = true;

    v.setAttribute('muted', '');



    /* Si el navegador ha congelado la descarga, forzar load(). Sólo cuando

       readyState es muy bajo, para no resetear vídeos casi cargados. */

    if (v.readyState <= 1) {

      try { v.load(); } catch (e) {}

    }



    /* Intento inmediato */

    try {

      var p = v.play();

      if (p && typeof p.catch === 'function') p.catch(function () {});

    } catch (e) {}



    /* Si ya hay un interval activo, no crear otro */

    if (v._hmdRetryInterval) return;



    /* Reintento persistente cada 1 segundo, hasta máximo 30 intentos.

       30s es tiempo de sobra para cargar incluso vídeos grandes con conexión

       lenta. Si tras 30s no arranca, es señal de un problema real (formato,

       codec, archivo dañado). */

    var intentos = 0;

    v._hmdRetryInterval = setInterval(function () {

      intentos++;

      /* Condiciones de salida */

      if (!v._hmdQuierePlay) {

        clearInterval(v._hmdRetryInterval);

        v._hmdRetryInterval = null;

        return;

      }

      if (!v.paused) {

        /* Ya está reproduciéndose, todo bien */

        clearInterval(v._hmdRetryInterval);

        v._hmdRetryInterval = null;

        return;

      }

      if (intentos > 30) {

        /* Abandonar tras 30s; el vídeo probablemente está roto */

        clearInterval(v._hmdRetryInterval);

        v._hmdRetryInterval = null;

        return;

      }

      /* Reintento: forzar muted de nuevo por si algo lo cambió */

      v.muted = true;

      /* Cada 5 intentos, forzar load() para "despertar" la descarga */

      if (intentos % 5 === 0 && v.readyState <= 2) {

        try { v.load(); } catch (e) {}

      }

      try {

        var p2 = v.play();

        if (p2 && typeof p2.catch === 'function') p2.catch(function () {});

      } catch (e) {}

    }, 1000);

  }



  function pausarVideo(v) {

    if (!v) return;

    v._hmdQuierePlay = false;

    /* Cancelar el interval de reintentos */

    if (v._hmdRetryInterval) {

      clearInterval(v._hmdRetryInterval);

      v._hmdRetryInterval = null;

    }

    if (!v.paused) {

      try { v.pause(); } catch (e) {}

    }

  }



  function initVideosFondo(scope) {

    var cont = scope || document;

    var vids = cont.querySelectorAll('.hmd-capa-video');

    for (var i = 0; i < vids.length; i++) {

      var v = vids[i];

      /* Respetar el flag: si el carrusel ya marcó este vídeo como "no play"

         (porque está en un slide inactivo o es un clon), no lo arrancamos. */

      if (v._hmdQuierePlay === false) continue;

      /* Si el vídeo está en un slide de carrusel que no está activo,
         no lo arrancamos: el carousel llama intentarPlayVideo() al activar
         ese slide. Evita descargar todos los vídeos al mismo tiempo, lo que
         bloqueaba el LCP (~36 MB de vídeo compitiendo con la imagen hero). */
      var _parentSlide = v.closest('[data-hmd-slide]');
      if (_parentSlide && !_parentSlide.classList.contains('is-activo')) continue;

      intentarPlayVideo(v);

    }

  }



  function initAll() {

    document.querySelectorAll('[data-hmd-banner]').forEach(initBanner);

    document.querySelectorAll('[data-hmd-carrusel]').forEach(initCarrusel);

    initVideosFondo(document);

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initAll);

  } else {

    initAll();

  }



  /* ===== Integración con el editor de temas ===== */

  function buscarCarrusel(target) {

    if (!target) return null;

    if (target.matches && target.matches('[data-hmd-carrusel]')) return target;

    var dentro = target.querySelector && target.querySelector('[data-hmd-carrusel]');

    if (dentro) return dentro;

    return target.closest && target.closest('[data-hmd-carrusel]');

  }



  document.addEventListener('shopify:section:unload', function (e) {

    var root = buscarCarrusel(e.target);

    if (!root) return;

    if (root.__hmdCarrusel && typeof root.__hmdCarrusel.destruir === 'function') {

      root.__hmdCarrusel.destruir();

      root.__hmdCarrusel = null;

    }

  });



  document.addEventListener('shopify:section:load', function (e) {

    var root = buscarCarrusel(e.target);

    if (!root) return;

    if (root.__hmdCarrusel && typeof root.__hmdCarrusel.destruir === 'function') {

      root.__hmdCarrusel.destruir();

    }

    root.__hmdCarrusel = null;

    requestAnimationFrame(function () {

      root.querySelectorAll('[data-hmd-banner]').forEach(function (banner) {

        banner.dataset.hmdAnimInit = '';

        banner.classList.remove('hmd-anim-visible');

        banner.querySelectorAll('[data-hmd-stat-num]').forEach(function (n) { n.dataset.hmdContadorInit = ''; });

        initBanner(banner);

      });

      initCarrusel(root);

      initVideosFondo(root);

    });

  });



  document.addEventListener('shopify:section:select', function (e) {

    var root = buscarCarrusel(e.target);

    if (root && root.__hmdCarrusel) root.__hmdCarrusel.mostrarSlide(0);

  });



  function irABloque(e) {

    var blockEl = e.target;

    if (!blockEl) return;

    var root = blockEl.closest && blockEl.closest('[data-hmd-carrusel]');

    var slide = blockEl.matches && blockEl.matches('[data-hmd-slide]') ? blockEl : (blockEl.closest && blockEl.closest('[data-hmd-slide]'));

    if (root && slide && root.__hmdCarrusel) {

      var idx = parseInt(slide.dataset.hmdIndex, 10) || 0;

      root.__hmdCarrusel.mostrarSlide(idx);

    }

  }



  document.addEventListener('shopify:block:select', irABloque);



})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-afiliados-01"] && !Shopify.designMode) return;
  try {
    
(function () {
  function animarNumero(numEl, duracion, callback) {
    var texto = numEl.textContent;
    var match = texto.match(/(\d+(?:[.,]\d+)?)/);
    if (!match) {
      callback();
      return;
    }
    var numStr = match[1];
    var finalNum = parseFloat(numStr.replace(',', '.'));
    var usarComa = numStr.indexOf(',') !== -1;
    var sepIdx = numStr.search(/[.,]/);
    var decimales = sepIdx === -1 ? 0 : (numStr.length - sepIdx - 1);
    var prefijo = texto.substring(0, match.index);
    var sufijo = texto.substring(match.index + numStr.length);
    var inicio = null;

    if (finalNum === 0) {
      callback();
      return;
    }

    function paso(ahora) {
      if (inicio === null) inicio = ahora;
      var t = Math.min((ahora - inicio) / duracion, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var valor = finalNum * eased;
      var salida = decimales > 0 ? valor.toFixed(decimales) : Math.floor(valor).toString();
      if (usarComa) salida = salida.replace('.', ',');
      numEl.textContent = prefijo + salida + sufijo;
      if (t < 1) {
        requestAnimationFrame(paso);
      } else {
        numEl.textContent = texto;
        callback();
      }
    }

    requestAnimationFrame(paso);
  }

  function configurarContador(elementos, numSelector, popClass, duracion, prefersReduced) {
    if (!elementos || !elementos.length) return;

    function animar(elemento) {
      var numEl = elemento.querySelector(numSelector);
      if (!numEl) return;
      if (prefersReduced) return;
      animarNumero(numEl, duracion, function () {
        elemento.classList.remove(popClass);
        void elemento.offsetWidth;
        elemento.classList.add(popClass);
      });
    }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(elementos, animar);
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          obs.unobserve(entry.target);
          animar(entry.target);
        }
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -40px 0px' });

    Array.prototype.forEach.call(elementos, function (el) { obs.observe(el); });
  }

  function configurarFade(seccion, prefersReduced) {
    var animables = seccion.querySelectorAll('.afiliados-anim');
    if (!animables.length) return;

    if (prefersReduced) {
      Array.prototype.forEach.call(animables, function (el) {
        el.classList.add('afiliados-anim-visible');
      });
      return;
    }

    var fadeRetraso = parseInt(seccion.dataset.afilFadeRetraso, 10);
    if (isNaN(fadeRetraso)) fadeRetraso = 0;
    var secuencia = seccion.dataset.afilFadeSec === '1';

    Array.prototype.forEach.call(animables, function (el) {
      if (secuencia && fadeRetraso > 0) {
        var i = parseInt(el.dataset.afiliadosAnimIdx, 10);
        if (isNaN(i)) i = 0;
        el.style.transitionDelay = (i * fadeRetraso) + 'ms';
      }
    });

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(animables, function (el) {
        el.classList.add('afiliados-anim-visible');
      });
      return;
    }

    var fadeObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('afiliados-anim-visible');
          fadeObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    Array.prototype.forEach.call(animables, function (el) { fadeObs.observe(el); });
  }

  function initSeccion(seccion) {
    if (!seccion) return;
    if (seccion.dataset.afiliadosInit === '1') return;
    seccion.dataset.afiliadosInit = '1';

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (seccion.dataset.afilAnim === '1') {
      var circuloDur = parseInt(seccion.dataset.afilNumDur, 10);
      if (isNaN(circuloDur) || circuloDur <= 0) circuloDur = 1400;
      var circulos = seccion.querySelectorAll('.afiliados-circulo');
      configurarContador(circulos, '.afiliados-circulo-numero', 'afiliados-circulo--pop', circuloDur, prefersReduced);
    }

    if (seccion.dataset.afilBadgeAnim === '1') {
      var badgeDur = parseInt(seccion.dataset.afilBadgeNumDur, 10);
      if (isNaN(badgeDur) || badgeDur <= 0) badgeDur = 1400;
      var badges = seccion.querySelectorAll('.afiliados-badge');
      configurarContador(badges, '.afiliados-badge-destacado', 'afiliados-badge--pop', badgeDur, prefersReduced);
    }

    configurarFade(seccion, prefersReduced);
  }

  var secciones = document.querySelectorAll('[data-afiliados-seccion]');
  Array.prototype.forEach.call(secciones, initSeccion);

  // Autoplay robusto de los videos en bucle de la columna de imagen
  var afilVideos = document.querySelectorAll('.afiliados-video');
  if (afilVideos.length) {
    var afilReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    Array.prototype.forEach.call(afilVideos, function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      if (afilReduce) return;
      var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      /* Sin arranque por 'loadeddata': ese evento se dispara en cuanto hay primer
         fotograma, esté o no la sección en pantalla, y el play() resultante tiraba
         del vídeo entero durante la carga inicial. El observer de abajo es el único
         disparador; con preload="none" no se descarga nada hasta que hace falta. */
      if ('IntersectionObserver' in window) {
        var vo = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { tryPlay(); } else { v.pause(); } });
        }, { threshold: 0.2 });
        vo.observe(v);
      } else { tryPlay(); }
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-afiliados-seccion]');
    if (s) {
      s.dataset.afiliadosInit = '';
      initSeccion(s);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-articulo-revista"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function slugify(txt) {
    return (txt || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim().replace(/\s+/g, '-').replace(/-+/g, '-')
      .slice(0, 60) || 'seccion';
  }

  function buildFaqSchema(seccion) {
    var prev = document.querySelector('script[data-artr-faq]');
    if (prev) prev.parentNode.removeChild(prev);
    var cuerpo = seccion.querySelector('[data-artr-cuerpo]');
    if (!cuerpo) return;
    var dets = cuerpo.querySelectorAll('details');
    if (!dets.length) return;
    var items = [];
    Array.prototype.forEach.call(dets, function (d) {
      var sum = d.querySelector('summary');
      if (!sum) return;
      var q = sum.textContent.trim();
      var ans = '';
      Array.prototype.forEach.call(d.children, function (el) {
        if (el.tagName && el.tagName.toLowerCase() === 'summary') return;
        ans += (el.textContent || '').trim() + ' ';
      });
      ans = ans.trim();
      if (q && ans) {
        items.push({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: ans } });
      }
    });
    if (!items.length) return;
    var data = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: items };
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.setAttribute('data-artr-faq', '');
    s.textContent = JSON.stringify(data);
    document.head.appendChild(s);
  }

  function initArticulo(seccion) {
    if (!seccion || seccion.dataset.artrInit === 'true') return;
    seccion.dataset.artrInit = 'true';

    buildFaqSchema(seccion);

    var cuerpo = seccion.querySelector('[data-artr-cuerpo]');
    var listaToc = seccion.querySelector('[data-artr-toc-lista]');
    var colToc = seccion.querySelector('[data-artr-toc-col]');
    var details = seccion.querySelector('[data-artr-toc-details]');

    if (!cuerpo || !listaToc) {
      if (colToc) colToc.style.display = 'none';
      return;
    }

    var headings = Array.prototype.slice.call(cuerpo.querySelectorAll('h2'));

    // Sin H2 suficientes -> ocultar el TOC entero.
    if (headings.length < 2) {
      if (colToc) colToc.style.display = 'none';
      return;
    }

    var enlaces = [];
    var usados = {};

    headings.forEach(function (h) {
      var base = h.id || slugify(h.textContent);
      var id = base, n = 2;
      while (usados[id]) { id = base + '-' + n; n++; }
      usados[id] = true;
      h.id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'artr-toc-enlace';
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      a.setAttribute('data-artr-target', id);
      li.appendChild(a);
      listaToc.appendChild(li);
      enlaces.push(a);

      a.addEventListener('click', function (e) {
        e.preventDefault();
        var destino = document.getElementById(id);
        if (!destino) return;
        destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
        // En movil, cerrar el desplegable tras navegar.
        if (details && details.open && window.matchMedia('(max-width: 989px)').matches) {
          details.open = false;
        }
      });
    });

    // En desktop el details va siempre abierto (CSS lo fuerza visible).
    function syncDetails() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        if (details) details.open = true;
      }
    }
    syncDetails();
    window.addEventListener('resize', syncDetails, { passive: true });

    // ----- Scroll-spy -----
    var porId = {};
    enlaces.forEach(function (a) { porId[a.getAttribute('data-artr-target')] = a; });
    var activo = null;

    function marcar(id) {
      if (activo === id) return;
      activo = id;
      enlaces.forEach(function (a) {
        var on = a.getAttribute('data-artr-target') === id;
        a.classList.toggle('artr-toc-activo', on);
        if (on) { a.setAttribute('aria-current', 'true'); } else { a.removeAttribute('aria-current'); }
      });
    }

    if ('IntersectionObserver' in window) {
      var visibles = {};
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          visibles[en.target.id] = en.isIntersecting ? en.boundingClientRect.top : null;
        });
        // El heading visible mas alto manda.
        var mejor = null, mejorTop = Infinity;
        headings.forEach(function (h) {
          if (visibles[h.id] != null && visibles[h.id] < mejorTop) { mejorTop = visibles[h.id]; mejor = h.id; }
        });
        if (mejor) {
          marcar(mejor);
        } else {
          // Ninguno intersectando: marcar el ultimo por encima del viewport.
          var ultimo = null;
          headings.forEach(function (h) {
            if (h.getBoundingClientRect().top < 120) ultimo = h.id;
          });
          if (ultimo) marcar(ultimo);
        }
      }, { rootMargin: '-15% 0px -70% 0px', threshold: [0, 1] });

      headings.forEach(function (h) { obs.observe(h); });
    } else {
      // Fallback sin IO: marcar el primero.
      marcar(headings[0].id);
    }
  }

  function init() {
    document.querySelectorAll('[data-artr-seccion]').forEach(initArticulo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = (e.target.matches && e.target.matches('[data-artr-seccion]'))
      ? e.target
      : e.target.querySelector && e.target.querySelector('[data-artr-seccion]');
    if (seccion) {
      delete seccion.dataset.artrInit;
      // Limpiar TOC previo para no duplicar.
      var lista = seccion.querySelector('[data-artr-toc-lista]');
      if (lista) lista.innerHTML = '';
      var col = seccion.querySelector('[data-artr-toc-col]');
      if (col) col.style.display = '';
      initArticulo(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-categorias-coleccion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCategorias(seccion) {
    if (seccion.dataset.catInit === 'true') return;
    seccion.dataset.catInit = 'true';

    var cards = seccion.querySelectorAll('[data-cat-card]');

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('cat-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('cat-visible');
          observer.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    cards.forEach(function (c) { observer.observe(c); });
  }

  function init() {
    document.querySelectorAll('[data-cat-seccion]').forEach(initCategorias);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = e.target.querySelector('[data-cat-seccion]');
    if (seccion) initCategorias(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-coleccion-destacada-01"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function dispararCartUpdated() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (data) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: data.item_count } }));
    }).catch(function () {});
  }

  function initVariantes(grupo) {
    if (grupo.dataset.colVarInit === 'true') return;
    grupo.dataset.colVarInit = 'true';

    var botones = grupo.querySelectorAll('[data-col-variante]');
    var tarjeta = grupo.closest('[data-col-tarjeta]');
    if (!tarjeta) return;
    var precioEl = tarjeta.querySelector('[data-col-precio]');
    var botonAdd = tarjeta.querySelector('[data-col-add]');
    var botonComprar = tarjeta.querySelector('[data-col-comprar]');
    var imagenEl = tarjeta.querySelector('[data-col-img-real]');
    var imagenOriginal = imagenEl ? imagenEl.getAttribute('src') : null;
    var subEl = tarjeta.querySelector('[data-col-subtitulo]');

    botones.forEach(function (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (boton.getAttribute('data-variant-disponible') === 'false') return;

        botones.forEach(function (b) { b.classList.remove('col-variante-activa'); });
        boton.classList.add('col-variante-activa');

        var precio = boton.getAttribute('data-variant-precio');
        var compare = boton.getAttribute('data-variant-compare');
        var id = boton.getAttribute('data-variant-id');
        var imagen = boton.getAttribute('data-variant-imagen');

        if (precioEl && precio) {
          if (compare && compare.length > 0) {
            precioEl.innerHTML = '<span class="col-precio-oferta">' + precio + '</span><span class="col-precio-antiguo">' + compare + '</span>';
          } else {
            precioEl.innerHTML = '<span class="col-precio-normal">' + precio + '</span>';
          }
        }
        if (botonAdd && id) botonAdd.setAttribute('data-variant', id);
        if (botonComprar && id) botonComprar.setAttribute('data-variant', id);
        if (imagenEl && imagen) imagenEl.setAttribute('src', imagen);
        var sub = boton.getAttribute('data-variant-subtitulo');
        if (subEl && sub !== null && sub !== '') subEl.textContent = sub;
      });
    });
  }

  function initBoton(boton) {
    if (boton.dataset.colInit === 'true') return;
    boton.dataset.colInit = 'true';

    boton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variant = boton.getAttribute('data-variant');
      if (!variant) return;

      var textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = 'Añadiendo...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variant, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('err');
        return r.json();
      }).then(function () {
        boton.classList.add('col-boton-ok');
        boton.textContent = 'Añadido';
        dispararCartUpdated();
        setTimeout(function () {
          boton.disabled = false;
          boton.classList.remove('col-boton-ok');
          boton.textContent = textoOriginal;
        }, 1600);
      }).catch(function () {
        boton.textContent = 'Error';
        setTimeout(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
        }, 2000);
      });
    });
  }

  function igualarNombres(seccion) {
    var grid = seccion.querySelector('[data-col-grid]');
    if (!grid) return;
    var modo = grid.getAttribute('data-col-igualar');
    if (!modo || modo === 'no') return;

    var nombres = grid.querySelectorAll('[data-col-nombre]');
    if (!nombres.length) return;

    nombres.forEach(function (n) { n.style.minHeight = ''; });

    if (modo === 'grid') {
      var maxAll = 0;
      nombres.forEach(function (n) {
        if (n.offsetHeight > maxAll) maxAll = n.offsetHeight;
      });
      nombres.forEach(function (n) { n.style.minHeight = maxAll + 'px'; });
    } else if (modo === 'fila') {
      var filas = {};
      nombres.forEach(function (n) {
        var top = Math.round(n.getBoundingClientRect().top);
        if (!filas[top]) filas[top] = [];
        filas[top].push(n);
      });
      Object.keys(filas).forEach(function (top) {
        var grupo = filas[top];
        var maxFila = 0;
        grupo.forEach(function (n) {
          if (n.offsetHeight > maxFila) maxFila = n.offsetHeight;
        });
        grupo.forEach(function (n) { n.style.minHeight = maxFila + 'px'; });
      });
    }
  }

  function igualarTodas() {
    document.querySelectorAll('[data-col]').forEach(igualarNombres);
  }

  function initComprar(boton) {
    if (boton.dataset.colCompraInit === 'true') return;
    boton.dataset.colCompraInit = 'true';

    boton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variant = boton.getAttribute('data-variant');
      if (!variant) return;

      var textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variant, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('err');
        window.location.href = '/checkout';
      }).catch(function () {
        boton.disabled = false;
        boton.textContent = textoOriginal;
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-col-add]').forEach(initBoton);
    document.querySelectorAll('[data-col-comprar]').forEach(initComprar);
    document.querySelectorAll('[data-col-variantes]').forEach(initVariantes);
    igualarTodas();
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(igualarTodas, 200);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(igualarTodas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-col]')) initAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-faq-clasica"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function cerrar(item) {
    var wrap = item.querySelector('[data-faqc-respuesta]');
    var boton = item.querySelector('[data-faqc-toggle]');
    item.classList.remove('faqc-abierto');
    if (boton) boton.setAttribute('aria-expanded', 'false');
    if (wrap) {
      wrap.style.setProperty('max-height', '0px', 'important');
    }
  }

  function abrir(item) {
    var wrap = item.querySelector('[data-faqc-respuesta]');
    var boton = item.querySelector('[data-faqc-toggle]');
    item.classList.add('faqc-abierto');
    if (boton) boton.setAttribute('aria-expanded', 'true');
    if (wrap) {
      wrap.style.setProperty('max-height', wrap.scrollHeight + 'px', 'important');
    }
  }

  function initFaq(seccion) {
    if (!seccion || seccion.dataset.faqInit === 'true') return;
    seccion.dataset.faqInit = 'true';

    var items = seccion.querySelectorAll('[data-faqc-item]');

    items.forEach(function (item) {
      var boton = item.querySelector('[data-faqc-toggle]');
      if (!boton) return;

      boton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var estaAbierto = item.classList.contains('faqc-abierto');

        items.forEach(function (otro) {
          if (otro !== item) cerrar(otro);
        });

        if (estaAbierto) {
          cerrar(item);
        } else {
          abrir(item);
        }
      });
    });

    window.addEventListener('resize', function () {
      var abierto = seccion.querySelector('.faqc-abierto');
      if (abierto) {
        var wrap = abierto.querySelector('[data-faqc-respuesta]');
        if (wrap) {
          wrap.style.setProperty('max-height', wrap.scrollHeight + 'px', 'important');
        }
      }
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-faqc-seccion]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = (e.target.matches && e.target.matches('[data-faqc-seccion]'))
      ? e.target
      : e.target.querySelector && e.target.querySelector('[data-faqc-seccion]');
    if (seccion) {
      delete seccion.dataset.faqInit;
      initFaq(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-faq-premium"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function cerrar(item) {
    var wrap = item.querySelector('[data-faq-respuesta]');
    var boton = item.querySelector('[data-faq-toggle]');
    item.classList.remove('faq-abierto');
    if (boton) boton.setAttribute('aria-expanded', 'false');
    if (wrap) {
      wrap.style.setProperty('max-height', '0px', 'important');
    }
  }

  function abrir(item) {
    var wrap = item.querySelector('[data-faq-respuesta]');
    var boton = item.querySelector('[data-faq-toggle]');
    item.classList.add('faq-abierto');
    if (boton) boton.setAttribute('aria-expanded', 'true');
    if (wrap) {
      wrap.style.setProperty('max-height', wrap.scrollHeight + 'px', 'important');
    }
  }

  function initFaq(seccion) {
    if (!seccion || seccion.dataset.faqInit === 'true') return;
    seccion.dataset.faqInit = 'true';

    var items = seccion.querySelectorAll('[data-faq-item]');

    items.forEach(function (item) {
      var boton = item.querySelector('[data-faq-toggle]');
      if (!boton) return;

      boton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var estaAbierto = item.classList.contains('faq-abierto');

        items.forEach(function (otro) {
          if (otro !== item) cerrar(otro);
        });

        if (estaAbierto) {
          cerrar(item);
        } else {
          abrir(item);
        }
      });
    });

    window.addEventListener('resize', function () {
      var abierto = seccion.querySelector('.faq-abierto');
      if (abierto) {
        var wrap = abierto.querySelector('[data-faq-respuesta]');
        if (wrap) {
          wrap.style.setProperty('max-height', wrap.scrollHeight + 'px', 'important');
        }
      }
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-faq-seccion]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = (e.target.matches && e.target.matches('[data-faq-seccion]'))
      ? e.target
      : e.target.querySelector && e.target.querySelector('[data-faq-seccion]');
    if (seccion) {
      delete seccion.dataset.faqInit;
      initFaq(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-faq-producto"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function cerrar(item) {
    var wrap = item.querySelector('[data-faq-respuesta]');
    var boton = item.querySelector('[data-faq-toggle]');
    item.classList.remove('faq-abierto');
    if (boton) boton.setAttribute('aria-expanded', 'false');
    if (wrap) {
      wrap.style.setProperty('max-height', '0px', 'important');
    }
  }

  function abrir(item) {
    var wrap = item.querySelector('[data-faq-respuesta]');
    var boton = item.querySelector('[data-faq-toggle]');
    item.classList.add('faq-abierto');
    if (boton) boton.setAttribute('aria-expanded', 'true');
    if (wrap) {
      wrap.style.setProperty('max-height', wrap.scrollHeight + 'px', 'important');
    }
  }

  function initFaq(seccion) {
    if (!seccion || seccion.dataset.faqInit === 'true') return;
    seccion.dataset.faqInit = 'true';

    var items = seccion.querySelectorAll('[data-faq-item]');

    items.forEach(function (item) {
      var boton = item.querySelector('[data-faq-toggle]');
      if (!boton) return;

      boton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var estaAbierto = item.classList.contains('faq-abierto');

        items.forEach(function (otro) {
          if (otro !== item) cerrar(otro);
        });

        if (estaAbierto) {
          cerrar(item);
        } else {
          abrir(item);
        }
      });
    });

    window.addEventListener('resize', function () {
      var abierto = seccion.querySelector('.faq-abierto');
      if (abierto) {
        var wrap = abierto.querySelector('[data-faq-respuesta]');
        if (wrap) {
          wrap.style.setProperty('max-height', wrap.scrollHeight + 'px', 'important');
        }
      }
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-faq-seccion]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = (e.target.matches && e.target.matches('[data-faq-seccion]'))
      ? e.target
      : e.target.querySelector && e.target.querySelector('[data-faq-seccion]');
    if (seccion) {
      delete seccion.dataset.faqInit;
      initFaq(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-flipcards"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFlipCards(seccion) {
    if (!seccion || seccion.dataset.flipcInit === 'true') return;
    seccion.dataset.flipcInit = 'true';

    var flips = seccion.querySelectorAll('[data-flipc-flip]');

    flips.forEach(function (interior) {
      function girar() {
        var girada = interior.classList.toggle('flipc-girada');
        interior.setAttribute('aria-pressed', girada ? 'true' : 'false');
      }

      interior.addEventListener('click', function (e) {
        e.preventDefault();
        girar();
      });

      interior.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          girar();
        }
      });
    });
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-flipc-seccion]').forEach(initFlipCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = (e.target.matches && e.target.matches('[data-flipc-seccion]'))
      ? e.target
      : (e.target.querySelector && e.target.querySelector('[data-flipc-seccion]'));
    if (seccion) {
      delete seccion.dataset.flipcInit;
      initFlipCards(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFmdFooter(footer) {
    if (!footer || footer.dataset.fmdInit === 'true') return;
    footer.dataset.fmdInit = 'true';

    var desplegables = footer.querySelectorAll('[data-fmd-desplegable]');
    if (!desplegables.length) return;

    desplegables.forEach(function (det) {
      var summary = det.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function () {
        var estaAbierto = det.hasAttribute('open');
        if (!estaAbierto) {
          desplegables.forEach(function (otro) {
            if (otro !== det && otro.hasAttribute('open')) {
              otro.removeAttribute('open');
            }
          });
        }
      });
    });

    document.addEventListener('click', function (e) {
      desplegables.forEach(function (det) {
        if (det.hasAttribute('open') && !det.contains(e.target)) {
          det.removeAttribute('open');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        desplegables.forEach(function (det) {
          if (det.hasAttribute('open')) det.removeAttribute('open');
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fmd-footer]').forEach(initFmdFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var footer = e.target.querySelector('[data-fmd-footer]');
    if (footer) initFmdFooter(footer);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-foto-scrollback"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCita(seccion) {
    if (seccion.dataset.citaAnimInit === 'true') return;
    seccion.dataset.citaAnimInit = 'true';

    var tipoAnim = '';
    seccion.classList.forEach(function (c) {
      if (c.indexOf('cita-anim-') === 0 && c !== 'cita-anim-visible') tipoAnim = c;
    });

    if (tipoAnim === 'cita-anim-ninguna' || tipoAnim === '') {
      seccion.classList.add('cita-anim-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      seccion.classList.add('cita-anim-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('cita-anim-visible');
          observer.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -60px 0px' });

    observer.observe(seccion);
  }

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var parallaxActivas = [];
  var ticking = false;
  var listenersPuestos = false;

  function pintarParallax() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < parallaxActivas.length; i++) {
      var item = parallaxActivas[i];
      var rect = item.sec.getBoundingClientRect();
      var centro = rect.top + rect.height / 2;
      var rel = (centro - vh / 2) / (vh / 2 + rect.height / 2); // ~ -1 .. 1
      if (rel > 1) rel = 1;
      if (rel < -1) rel = -1;
      var desplaz = rel * rect.height * 0.12 * -1; // mueve el fondo en sentido contrario
      item.bg.style.transform = 'translate3d(0,' + desplaz.toFixed(1) + 'px,0)';
    }
  }

  // Coalescido: como mucho 1 cálculo por frame y SOLO al hacer scroll/resize.
  // (Antes el rAF giraba en bucle perpetuo llamando getBoundingClientRect por
  //  frame aunque no hubiera scroll => reflow forzado continuo.)
  function solicitarPintado() {
    if (!ticking && parallaxActivas.length) {
      ticking = true;
      requestAnimationFrame(pintarParallax);
    }
  }

  function engancharListeners() {
    if (listenersPuestos) return;
    listenersPuestos = true;
    window.addEventListener('scroll', solicitarPintado, { passive: true });
    window.addEventListener('resize', solicitarPintado, { passive: true });
  }

  function initParallax(seccion) {
    if (prefersReduced) return;
    if (seccion.dataset.citaParallaxInit === 'true') return;
    if (seccion.className.indexOf('cita-parallax') === -1) return;
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    var bg = seccion.querySelector('[data-cita-bg]');
    if (!bg) return;
    seccion.dataset.citaParallaxInit = 'true';

    if (!('IntersectionObserver' in window)) {
      parallaxActivas.push({ sec: seccion, bg: bg });
      engancharListeners();
      solicitarPintado();
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var existe = parallaxActivas.some(function (x) { return x.sec === seccion; });
        if (e.isIntersecting && !existe) {
          parallaxActivas.push({ sec: seccion, bg: bg });
          engancharListeners();
          solicitarPintado();
        } else if (!e.isIntersecting && existe) {
          parallaxActivas = parallaxActivas.filter(function (x) { return x.sec !== seccion; });
        }
      });
    }, { rootMargin: '120px 0px 120px 0px' });

    obs.observe(seccion);
  }

  function init() {
    document.querySelectorAll('[data-cita-seccion]').forEach(function (s) {
      initCita(s);
      initParallax(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = e.target.querySelector('[data-cita-seccion]');
    if (seccion) {
      seccion.dataset.citaAnimInit = '';
      seccion.dataset.citaParallaxInit = '';
      initCita(seccion);
      initParallax(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-ingredientes-pdp-flipcards"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFlipCards(seccion) {
    if (!seccion || seccion.dataset.ingflipInit === 'true') return;
    seccion.dataset.ingflipInit = 'true';

    var flips = seccion.querySelectorAll('[data-ingflip-flip]');

    function mostrar(objetivo) {
      flips.forEach(function (f) {
        var abrir = f === objetivo;
        f.classList.toggle('ingflip-girada', abrir);
        f.setAttribute('aria-pressed', abrir ? 'true' : 'false');
      });
    }

    flips.forEach(function (interior) {
      function girar() {
        var abrir = !interior.classList.contains('ingflip-girada');
        mostrar(abrir ? interior : null);
      }

      interior.addEventListener('click', function (e) {
        e.preventDefault();
        girar();
      });

      interior.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          girar();
        }
      });
    });

    var auto = seccion.dataset.ingflipAuto === 'true';
    var intervalo = parseInt(seccion.dataset.ingflipIntervalo, 10);
    if (!intervalo || intervalo < 500) intervalo = 4000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (auto && !reduce && flips.length > 1) {
      var timer = null;
      var pausado = false;

      function abrirAleatoria() {
        if (pausado) return;
        var candidatas = [];
        flips.forEach(function (f) {
          if (!f.classList.contains('ingflip-girada')) candidatas.push(f);
        });
        if (!candidatas.length) return;
        mostrar(candidatas[Math.floor(Math.random() * candidatas.length)]);
      }

      function arrancar() { if (!timer) { timer = setInterval(abrirAleatoria, intervalo); } }
      function parar() { if (timer) { clearInterval(timer); timer = null; } }

      seccion.addEventListener('mouseenter', function () { pausado = true; });
      seccion.addEventListener('mouseleave', function () { pausado = false; });
      seccion.addEventListener('focusin', function () { pausado = true; });
      seccion.addEventListener('focusout', function () { pausado = false; });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { parar(); } else { arrancar(); }
      });

      arrancar();
    }
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-ingflip-seccion]').forEach(initFlipCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = (e.target.matches && e.target.matches('[data-ingflip-seccion]'))
      ? e.target
      : (e.target.querySelector && e.target.querySelector('[data-ingflip-seccion]'));
    if (seccion) {
      delete seccion.dataset.ingflipInit;
      initFlipCards(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-ingredientes-pdp-premium"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function uniformarAlturas(seccion) {
    var tarjetas = seccion.querySelectorAll('[data-ingprem-tarjeta]');
    if (!tarjetas.length) return;
    var i, max = 0;
    for (i = 0; i < tarjetas.length; i++) { tarjetas[i].style.height = 'auto'; }
    for (i = 0; i < tarjetas.length; i++) {
      if (tarjetas[i].offsetHeight > max) max = tarjetas[i].offsetHeight;
    }
    for (i = 0; i < tarjetas.length; i++) { tarjetas[i].style.height = max + 'px'; }
  }

  function initFlipCards(seccion) {
    if (!seccion || seccion.dataset.ingpremInit === 'true') return;
    seccion.dataset.ingpremInit = 'true';

    var flips = seccion.querySelectorAll('[data-ingprem-flip]');

    function mostrar(objetivo) {
      flips.forEach(function (f) {
        var abrir = f === objetivo;
        f.classList.toggle('ingprem-girada', abrir);
        f.setAttribute('aria-pressed', abrir ? 'true' : 'false');
      });
    }

    flips.forEach(function (interior) {
      function girar() {
        var abrir = !interior.classList.contains('ingprem-girada');
        mostrar(abrir ? interior : null);
      }

      interior.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        e.preventDefault();
        girar();
      });

      interior.addEventListener('keydown', function (e) {
        if (e.target.closest('a')) return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          girar();
        }
      });
    });

    uniformarAlturas(seccion);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { uniformarAlturas(seccion); });
    }
    window.addEventListener('load', function () { uniformarAlturas(seccion); });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { uniformarAlturas(seccion); }, 150);
    });

    var auto = seccion.dataset.ingpremAuto === 'true';
    var intervalo = parseInt(seccion.dataset.ingpremIntervalo, 10);
    if (!intervalo || intervalo < 500) intervalo = 4000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (auto && !reduce && flips.length > 1) {
      var timer = null;
      var pausado = false;

      function abrirAleatoria() {
        if (pausado) return;
        var candidatas = [];
        flips.forEach(function (f) {
          if (!f.classList.contains('ingprem-girada')) candidatas.push(f);
        });
        if (!candidatas.length) return;
        mostrar(candidatas[Math.floor(Math.random() * candidatas.length)]);
      }

      function arrancar() { if (!timer) { timer = setInterval(abrirAleatoria, intervalo); } }
      function parar() { if (timer) { clearInterval(timer); timer = null; } }

      seccion.addEventListener('mouseenter', function () { pausado = true; });
      seccion.addEventListener('mouseleave', function () { pausado = false; });
      seccion.addEventListener('focusin', function () { pausado = true; });
      seccion.addEventListener('focusout', function () { pausado = false; });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { parar(); } else { arrancar(); }
      });

      arrancar();
    }
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-ingprem-seccion]').forEach(initFlipCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = (e.target.matches && e.target.matches('[data-ingprem-seccion]'))
      ? e.target
      : (e.target.querySelector && e.target.querySelector('[data-ingprem-seccion]'));
    if (seccion) {
      delete seccion.dataset.ingpremInit;
      initFlipCards(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-kit-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }

  function initSeccion(seccion) {
    if (seccion.dataset.mdkitInit === 'true') return;
    seccion.dataset.mdkitInit = 'true';

    var tramosWrap = seccion.querySelector('[data-mdkit-tramos]');
    var tramoBtns = Array.prototype.slice.call(seccion.querySelectorAll('[data-mdkit-tramo]'));
    var progresoEl = seccion.querySelector('[data-mdkit-progreso]');
    var progresoTxtEl = seccion.querySelector('[data-mdkit-progreso-txt]');
    var barraEl = seccion.querySelector('[data-mdkit-barra]');
    var envioTachadoEl = seccion.querySelector('[data-mdkit-envio-tachado]');
    var ahorroTotalEl = seccion.querySelector('[data-mdkit-ahorro-total]');
    var costeEnvio = parseInt(seccion.getAttribute('data-envio-coste'), 10) || 0;
    var umbralEnvio = parseInt(seccion.getAttribute('data-envio-umbral'), 10) || 0;
    var ahorroLabel = seccion.getAttribute('data-ahorro-label') || 'Te ahorras';
    var itemsEl = seccion.querySelector('[data-mdkit-items]');
    var vacioEl = seccion.querySelector('[data-mdkit-vacio]');
    var subtotalEl = seccion.querySelector('[data-mdkit-subtotal]');
    var filaAhorroEl = seccion.querySelector('[data-mdkit-fila-ahorro]');
    var ahorroEl = seccion.querySelector('[data-mdkit-ahorro]');
    var ahorroPctEl = seccion.querySelector('[data-mdkit-ahorro-pct]');
    var envioEl = seccion.querySelector('[data-mdkit-envio]');
    var totalEl = seccion.querySelector('[data-mdkit-total]');
    var ctaEl = seccion.querySelector('[data-mdkit-cta]');
    var ctaTxtEl = seccion.querySelector('[data-mdkit-cta-txt]');
    var addBtns = Array.prototype.slice.call(seccion.querySelectorAll('[data-mdkit-add]'));

    if (!tramoBtns.length || !itemsEl) return;

    var envioPendiente = envioEl ? envioEl.textContent : '';
    var ctaTextoBase = ctaTxtEl ? ctaTxtEl.textContent : 'Añadir kit al carrito';

    // Tramos ordenados por mínimo asc.
    var tramos = tramoBtns.map(function (btn) {
      return {
        btn: btn,
        min: parseInt(btn.getAttribute('data-min'), 10) || 0,
        pct: parseFloat(btn.getAttribute('data-pct')) || 0,
        envio: btn.getAttribute('data-envio') === 'true',
        abierto: btn.getAttribute('data-abierto') === 'true'
      };
    }).sort(function (a, b) { return a.min - b.min; });

    var minGlobal = tramos.length ? tramos[0].min : 1;
    var kit = {}; // variantId -> { id, precio, titulo, img, qty }
    var orden = []; // mantiene orden de inserción de variantIds

    function totalUnidades() {
      var n = 0;
      orden.forEach(function (k) { n += kit[k].qty; });
      return n;
    }

    function tramoAlcanzado(n) {
      var actual = null;
      tramos.forEach(function (t) { if (n >= t.min) actual = t; });
      return actual;
    }

    function siguienteTramo(n) {
      var sig = null;
      for (var i = 0; i < tramos.length; i++) {
        if (tramos[i].min > n) { sig = tramos[i]; break; }
      }
      return sig;
    }

    function beneficio(pct, envio) {
      var partes = [];
      if (pct > 0) partes.push('un <strong>' + pct + '\u00a0%</strong> de descuento');
      if (envio) partes.push('<strong>envío gratis</strong>');
      return partes.join(' y ') || 'tu kit';
    }

    function renderItems() {
      itemsEl.innerHTML = '';
      orden.forEach(function (k) {
        var it = kit[k];
        var row = document.createElement('div');
        row.className = 'mdkit__item';

        var img = it.img
          ? '<img class="mdkit__item-img" src="' + it.img + '" alt="" width="44" height="44">'
          : '<span class="mdkit__item-img"></span>';

        row.innerHTML =
          img +
          '<div class="mdkit__item-info">' +
            '<div class="mdkit__item-tit">' + it.titulo + '</div>' +
            '<div class="mdkit__item-precio">' + euros(it.precio) + '</div>' +
          '</div>' +
          '<div class="mdkit__item-qty">' +
            '<button type="button" class="mdkit__qty-btn" data-menos aria-label="Quitar una unidad">−</button>' +
            '<span class="mdkit__qty-val">' + it.qty + '</span>' +
            '<button type="button" class="mdkit__qty-btn" data-mas aria-label="Añadir una unidad">+</button>' +
          '</div>';

        row.querySelector('[data-menos]').addEventListener('click', function () { cambiarQty(k, -1); });
        row.querySelector('[data-mas]').addEventListener('click', function () { cambiarQty(k, 1); });
        itemsEl.appendChild(row);
      });
    }

    function render() {
      var n = totalUnidades();
      var hay = n > 0;

      if (vacioEl) vacioEl.style.display = hay ? 'none' : '';
      renderItems();

      var subtotal = 0;
      orden.forEach(function (k) { subtotal += kit[k].precio * kit[k].qty; });

      // Los packs no se eligen: se enciende solo el tramo alcanzado con las unidades del kit.
      var tAlc = tramoAlcanzado(n);
      tramos.forEach(function (t) {
        if (t === tAlc) t.btn.setAttribute('aria-current', 'true'); else t.btn.removeAttribute('aria-current');
      });
      var pct = tAlc ? tAlc.pct : 0;
      var ahorro = Math.round(subtotal * pct / 100);
      var neto = subtotal - ahorro;
      // El envío gratis lo decide el importe (igual que la tarifa de Shopify), no el pack.
      var envioGratis = hay && umbralEnvio > 0 && neto >= umbralEnvio;
      var total = neto + (hay && !envioGratis ? costeEnvio : 0);
      var ahorroTotal = ahorro + (envioGratis ? costeEnvio : 0);
      var pctTotal = ahorroTotal > 0 ? Math.round(ahorroTotal * 100 / (subtotal + costeEnvio)) : 0;

      if (subtotalEl) subtotalEl.textContent = hay ? euros(subtotal) : '—';
      if (filaAhorroEl) filaAhorroEl.hidden = !(hay && ahorro > 0);
      if (ahorroEl) ahorroEl.textContent = '− ' + euros(ahorro);
      if (ahorroPctEl) ahorroPctEl.textContent = (hay && pct > 0) ? ' · −' + pct + '\u00a0%' : '';
      if (envioEl) {
        if (envioGratis) { envioEl.textContent = 'Gratis'; envioEl.classList.add('mdkit__envio-ok'); }
        else { envioEl.textContent = hay && costeEnvio ? euros(costeEnvio) : envioPendiente; envioEl.classList.remove('mdkit__envio-ok'); }
      }
      if (envioTachadoEl) {
        envioTachadoEl.textContent = euros(costeEnvio);
        envioTachadoEl.hidden = !(envioGratis && costeEnvio > 0);
      }
      if (totalEl) totalEl.textContent = hay ? euros(total) : '—';
      if (ahorroTotalEl) {
        ahorroTotalEl.hidden = !(hay && ahorroTotal > 0);
        ahorroTotalEl.textContent = ahorroLabel + ' ' + euros(ahorroTotal) + ' (' + pctTotal + '\u00a0%)';
      }

      // Progreso: qué tienes y cuánto falta para el siguiente pack.
      if (progresoEl) {
        progresoEl.hidden = n === 0;
        var sig = siguienteTramo(n);
        var txt;
        if (!tAlc) {
          txt = 'Añade <strong>' + (minGlobal - n) + '</strong> más y consigue ' + beneficio(tramos[0].pct, tramos[0].envio) + '.';
        } else if (sig) {
          txt = 'Tienes ' + beneficio(pct, envioGratis) + '. Añade <strong>' + (sig.min - n) + '</strong> más y sube al <strong>' + sig.pct + '\u00a0%</strong>.';
        } else {
          txt = '✓ Tienes el máximo: ' + beneficio(pct, envioGratis) + '.';
        }
        if (progresoTxtEl) progresoTxtEl.innerHTML = txt;
        if (barraEl) barraEl.style.width = Math.min(100, n * 100 / tramos[tramos.length - 1].min) + '%';
      }

      var minRequerido = minGlobal;
      var ok = n >= minRequerido;
      if (ctaEl) ctaEl.disabled = !ok;
      if (ctaTxtEl) {
        if (n === 0) ctaTxtEl.textContent = ctaTextoBase;
        else if (!ok) ctaTxtEl.textContent = 'Añade ' + (minRequerido - n) + ' para tu kit';
        else ctaTxtEl.textContent = ctaTextoBase;
      }
    }

    function cambiarQty(k, delta) {
      if (!kit[k]) return;
      kit[k].qty += delta;
      if (kit[k].qty <= 0) {
        delete kit[k];
        orden = orden.filter(function (x) { return x !== k; });
      }
      render();
    }

    function anadir(btn) {
      var sel = btn.parentNode.querySelector('[data-mdkit-variant]');
      var id, precio;
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        id = sel.value;
        precio = parseInt(opt.getAttribute('data-precio'), 10) || 0;
      } else {
        id = btn.getAttribute('data-id');
        precio = parseInt(btn.getAttribute('data-precio'), 10) || 0;
      }
      if (!id) return;

      if (kit[id]) {
        kit[id].qty += 1;
      } else {
        kit[id] = {
          id: id,
          precio: precio,
          titulo: btn.getAttribute('data-titulo') || '',
          img: btn.getAttribute('data-img') || '',
          qty: 1
        };
        orden.push(id);
      }

      btn.classList.add('is-added');
      var t = btn.textContent;
      btn.textContent = '✓ Añadido';
      setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = t; }, 900);

      render();
    }

    function anadirAlCarrito() {
      var items = orden.map(function (k) {
        return { id: parseInt(kit[k].id, 10), quantity: kit[k].qty, properties: { _kit: 'pack-' + totalUnidades() } };
      });
      if (!items.length) return;

      ctaEl.disabled = true;
      var prev = ctaTxtEl.textContent;
      ctaTxtEl.textContent = 'Añadiendo…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('err');
        return r.json();
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (seccion.getAttribute('data-redirige') === 'true') {
          window.location.href = '/cart';
          return;
        }
        ctaTxtEl.textContent = '✓ Añadido al carrito';
        setTimeout(function () { ctaEl.disabled = false; ctaTxtEl.textContent = prev; }, 1800);
      }).catch(function () {
        ctaTxtEl.textContent = 'Error, inténtalo de nuevo';
        setTimeout(function () { ctaEl.disabled = false; ctaTxtEl.textContent = prev; }, 2200);
      });
    }

    addBtns.forEach(function (b) { b.addEventListener('click', function () { anadir(b); }); });
    if (ctaEl) ctaEl.addEventListener('click', anadirAlCarrito);

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-mdkit]').forEach(initSeccion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-mdkit]');
    if (s) { s.dataset.mdkitInit = ''; initSeccion(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-kit-packs"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function initSection(sec) {
    if (sec.dataset.mdpkInit === '1') return;
    sec.dataset.mdpkInit = '1';
    var btns = Array.prototype.slice.call(sec.querySelectorAll('[data-mdpk-add]'));
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ids = (btn.getAttribute('data-variants') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        var nombre = btn.getAttribute('data-nombre') || 'Pack';
        var items = ids.map(function (id) {
          return { id: parseInt(id, 10), quantity: 1, properties: { _kit: nombre } };
        });
        var prev = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = 'Añadiendo…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('err');
          return r.json();
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (sec.getAttribute('data-redirige') === 'true') { window.location.href = '/cart'; return; }
          btn.innerHTML = '✓ Añadido';
          setTimeout(function () { btn.disabled = false; btn.innerHTML = prev; }, 1800);
        }).catch(function () {
          btn.textContent = 'Error, reintenta';
          setTimeout(function () { btn.disabled = false; btn.innerHTML = prev; }, 2200);
        });
      });
    });
  }
  function initAll() { document.querySelectorAll('[data-mdpk]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-mdpk]');
    if (s) { s.dataset.mdpkInit = ''; initSection(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-newsletter-02"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function copiar(texto) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(texto);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = texto;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  function initCopiar(seccion) {
    var boton = seccion.querySelector('[data-cupon-codigo]');
    if (!boton) return;

    boton.addEventListener('click', function () {
      var codigo = boton.getAttribute('data-cupon-codigo') || '';
      if (!codigo) return;
      copiar(codigo).then(function () {
        boton.classList.add('cupon-copiado');
        setTimeout(function () {
          boton.classList.remove('cupon-copiado');
        }, 1800);
      }).catch(function () {
        boton.classList.add('cupon-copiado');
        setTimeout(function () {
          boton.classList.remove('cupon-copiado');
        }, 1800);
      });
    });
  }

  function animarNumero(numEl, duracion, callback) {
    var texto = numEl.textContent;
    var match = texto.match(/(\d+(?:[.,]\d+)?)/);
    if (!match) {
      callback();
      return;
    }
    var numStr = match[1];
    var finalNum = parseFloat(numStr.replace(',', '.'));
    var usarComa = numStr.indexOf(',') !== -1;
    var sepIdx = numStr.search(/[.,]/);
    var decimales = sepIdx === -1 ? 0 : (numStr.length - sepIdx - 1);
    var prefijo = texto.substring(0, match.index);
    var sufijo = texto.substring(match.index + numStr.length);
    var inicio = null;

    if (finalNum === 0) {
      callback();
      return;
    }

    function paso(ahora) {
      if (inicio === null) inicio = ahora;
      var t = Math.min((ahora - inicio) / duracion, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var valor = finalNum * eased;
      var salida = decimales > 0 ? valor.toFixed(decimales) : Math.floor(valor).toString();
      if (usarComa) salida = salida.replace('.', ',');
      numEl.textContent = prefijo + salida + sufijo;
      if (t < 1) {
        requestAnimationFrame(paso);
      } else {
        numEl.textContent = texto;
        callback();
      }
    }

    requestAnimationFrame(paso);
  }

  function initBoom(seccion) {
    if (seccion.dataset.cupAnim !== '1') return;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var contenedor = seccion.querySelector('.cupon-izq-numero');
    var numEl = seccion.querySelector('.cupon-izq-numero-valor');
    if (!contenedor || !numEl) return;

    var duracion = parseInt(seccion.dataset.cupNumDur, 10);
    if (isNaN(duracion) || duracion <= 0) duracion = 1400;

    function disparar() {
      animarNumero(numEl, duracion, function () {
        contenedor.classList.remove('cupon-izq-numero--pop');
        void contenedor.offsetWidth;
        contenedor.classList.add('cupon-izq-numero--pop');
      });
    }

    if (!('IntersectionObserver' in window)) {
      disparar();
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          obs.unobserve(entry.target);
          disparar();
        }
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -40px 0px' });

    obs.observe(contenedor);
  }

  function initTilt(seccion) {
    if (seccion.dataset.cupTilt !== '1') return;

    // No tilt en táctil
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

    // No tilt si reduced motion
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var wrap = seccion.querySelector('[data-cupon-tilt-wrap]');
    var tarjeta = seccion.querySelector('[data-cupon-tarjeta]');
    if (!wrap || !tarjeta) return;

    var estilos = getComputedStyle(seccion);
    var maxGrados = parseFloat(estilos.getPropertyValue('--cup-tilt-max-grados')) || 8;
    var suavidad = parseFloat(estilos.getPropertyValue('--cup-tilt-suavidad')) || 0.15;
    var escalaHover = parseFloat(estilos.getPropertyValue('--cup-tilt-escala')) || 1.02;
    var conBrillo = seccion.dataset.cupTiltBrillo === '1';

    var rectCache = null;
    var rafId = null;
    var targetRotX = 0;
    var targetRotY = 0;
    var targetScale = 1;
    var currentRotX = 0;
    var currentRotY = 0;
    var currentScale = 1;
    var brilloX = 50;
    var brilloY = 50;
    var dentro = false;

    function actualizarRect() {
      rectCache = tarjeta.getBoundingClientRect();
    }

    function aplicarTransform() {
      currentRotX += (targetRotX - currentRotX) * suavidad;
      currentRotY += (targetRotY - currentRotY) * suavidad;
      currentScale += (targetScale - currentScale) * suavidad;

      tarjeta.style.transform =
        'perspective(var(--cup-tilt-perspectiva)) ' +
        'rotateX(' + currentRotX.toFixed(2) + 'deg) ' +
        'rotateY(' + currentRotY.toFixed(2) + 'deg) ' +
        'scale3d(' + currentScale.toFixed(3) + ',' + currentScale.toFixed(3) + ',1)';

      if (conBrillo) {
        tarjeta.style.setProperty('--cup-tilt-brillo-x', brilloX.toFixed(1) + '%');
        tarjeta.style.setProperty('--cup-tilt-brillo-y', brilloY.toFixed(1) + '%');
      }

      var diffX = Math.abs(currentRotX - targetRotX);
      var diffY = Math.abs(currentRotY - targetRotY);
      var diffS = Math.abs(currentScale - targetScale);

      if (dentro || diffX > 0.01 || diffY > 0.01 || diffS > 0.001) {
        rafId = requestAnimationFrame(aplicarTransform);
      } else {
        rafId = null;
        if (!dentro) {
          tarjeta.style.transform = '';
          tarjeta.classList.remove('cupon-tilt-activo');
        }
      }
    }

    function onMove(e) {
      if (!rectCache) actualizarRect();
      var r = rectCache;
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;
      var px = (x / r.width) - 0.5;   // -0.5 a 0.5
      var py = (y / r.height) - 0.5;

      targetRotY = px * maxGrados * 2;       // izq/der
      targetRotX = -py * maxGrados * 2;      // arriba/abajo (invertido para "seguir" cursor)
      brilloX = (px + 0.5) * 100;
      brilloY = (py + 0.5) * 100;

      if (!rafId) rafId = requestAnimationFrame(aplicarTransform);
    }

    function onEnter() {
      dentro = true;
      actualizarRect();
      targetScale = escalaHover;
      tarjeta.classList.add('cupon-tilt-activo', 'cupon-tilt-hover');
      if (!rafId) rafId = requestAnimationFrame(aplicarTransform);
    }

    function onLeave() {
      dentro = false;
      targetRotX = 0;
      targetRotY = 0;
      targetScale = 1;
      tarjeta.classList.remove('cupon-tilt-hover');
      // dejamos cupon-tilt-activo hasta que termine animación; aplicarTransform lo limpia
      if (!rafId) rafId = requestAnimationFrame(aplicarTransform);
    }

    wrap.addEventListener('mouseenter', onEnter);
    wrap.addEventListener('mousemove', onMove);
    wrap.addEventListener('mouseleave', onLeave);
    window.addEventListener('scroll', function () { rectCache = null; }, { passive: true });
    window.addEventListener('resize', function () { rectCache = null; });
  }

  // Al enviar, Shopify recarga la página y salta al formulario: la cabecera fija tapaba el mensaje.
  function mostrarMensaje(seccion) {
    var msg = seccion.querySelector('.cupon-form-mensaje');
    if (!msg) return;
    setTimeout(function () { msg.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 150);
  }

  function initCupon(seccion) {
    if (!seccion || seccion.dataset.cuponInit === 'true') return;
    seccion.dataset.cuponInit = 'true';
    initCopiar(seccion);
    initBoom(seccion);
    initTilt(seccion);
    mostrarMensaje(seccion);
  }

  function init() {
    document.querySelectorAll('[data-cupon-seccion]').forEach(initCupon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = (e.target.matches && e.target.matches('[data-cupon-seccion]'))
      ? e.target
      : (e.target.querySelector && e.target.querySelector('[data-cupon-seccion]'));
    if (seccion) {
      delete seccion.dataset.cuponInit;
      initCupon(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-newsletter-03"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function animarNumero(numEl, duracion, callback) {
    var texto = numEl.textContent;
    var match = texto.match(/(\d+(?:[.,]\d+)?)/);
    if (!match) {
      callback();
      return;
    }
    var numStr = match[1];
    var finalNum = parseFloat(numStr.replace(',', '.'));
    var usarComa = numStr.indexOf(',') !== -1;
    var sepIdx = numStr.search(/[.,]/);
    var decimales = sepIdx === -1 ? 0 : (numStr.length - sepIdx - 1);
    var prefijo = texto.substring(0, match.index);
    var sufijo = texto.substring(match.index + numStr.length);
    var inicio = null;

    if (finalNum === 0) {
      callback();
      return;
    }

    function paso(ahora) {
      if (inicio === null) inicio = ahora;
      var t = Math.min((ahora - inicio) / duracion, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var valor = finalNum * eased;
      var salida = decimales > 0 ? valor.toFixed(decimales) : Math.floor(valor).toString();
      if (usarComa) salida = salida.replace('.', ',');
      numEl.textContent = prefijo + salida + sufijo;
      if (t < 1) {
        requestAnimationFrame(paso);
      } else {
        numEl.textContent = texto;
        callback();
      }
    }

    requestAnimationFrame(paso);
  }

  function initSeccion(seccion) {
    if (!seccion || seccion.dataset.cupedlInit === 'true') return;
    seccion.dataset.cupedlInit = 'true';

    if (seccion.dataset.cupedlAnim !== '1') return;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var numEl = seccion.querySelector('[data-cupedl-num]');
    if (!numEl) return;

    var duracion = parseInt(seccion.dataset.cupedlNumDur, 10);
    if (isNaN(duracion) || duracion <= 0) duracion = 1400;

    function disparar() {
      animarNumero(numEl, duracion, function () {
        numEl.classList.remove('cupedl-num--pop');
        void numEl.offsetWidth;
        numEl.classList.add('cupedl-num--pop');
      });
    }

    if (!('IntersectionObserver' in window)) {
      disparar();
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          obs.unobserve(entry.target);
          disparar();
        }
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -40px 0px' });

    obs.observe(numEl);
  }

  function init() {
    document.querySelectorAll('[data-cupedl-seccion]').forEach(initSeccion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = (e.target.matches && e.target.matches('[data-cupedl-seccion]'))
      ? e.target
      : (e.target.querySelector && e.target.querySelector('[data-cupedl-seccion]'));
    if (s) {
      delete s.dataset.cupedlInit;
      initSeccion(s);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-pestana-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPestanasProducto(root) {
      if (!root || root.dataset.pestanasInit === 'true') return;
      root.dataset.pestanasInit = 'true';

      var botones = root.querySelectorAll('.pestanas-producto-boton');
      var paneles = root.querySelectorAll('.pestanas-producto-panel');

      function activarPestana(targetId) {
        botones.forEach(function (btn) {
          var esActiva = btn.getAttribute('data-pestana-target') === targetId;
          btn.classList.toggle('pestanas-producto-boton-activa', esActiva);
          btn.setAttribute('aria-selected', esActiva ? 'true' : 'false');
        });

        paneles.forEach(function (panel) {
          var esActivo = panel.id === targetId;
          panel.classList.toggle('pestanas-producto-panel-activo', esActivo);
          if (esActivo) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      botones.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-pestana-target');
          if (target) activarPestana(target);
        });

        btn.addEventListener('keydown', function (e) {
          var lista = Array.prototype.slice.call(botones);
          var indice = lista.indexOf(btn);
          var siguiente = null;

          if (e.key === 'ArrowRight') {
            siguiente = lista[(indice + 1) % lista.length];
          } else if (e.key === 'ArrowLeft') {
            siguiente = lista[(indice - 1 + lista.length) % lista.length];
          }

          if (siguiente) {
            e.preventDefault();
            siguiente.focus();
            var target = siguiente.getAttribute('data-pestana-target');
            if (target) activarPestana(target);
          }
        });
      });

      var cabeceras = root.querySelectorAll('[data-acordeon-cabecera]');

      function cerrarAcordeon(panel) {
        panel.classList.remove('pestanas-producto-acordeon-abierto');
        panel.classList.remove('pestanas-producto-acordeon-parcial');
        var cab = panel.querySelector('[data-acordeon-cabecera]');
        if (cab) {
          cab.classList.remove('pestanas-producto-acordeon-cabecera-activa');
          cab.setAttribute('aria-expanded', 'false');
        }
      }

      function abrirAcordeon(panel) {
        panel.classList.add('pestanas-producto-acordeon-abierto');
        if (panel.hasAttribute('data-pestana-parcial')) {
          panel.classList.add('pestanas-producto-acordeon-parcial');
        }
        var cab = panel.querySelector('[data-acordeon-cabecera]');
        if (cab) {
          cab.classList.add('pestanas-producto-acordeon-cabecera-activa');
          cab.setAttribute('aria-expanded', 'true');
        }
      }

      function expandirCompleto(panel) {
        panel.classList.remove('pestanas-producto-acordeon-parcial');
        panel.classList.add('pestanas-producto-acordeon-abierto');
      }

      cabeceras.forEach(function (cab) {
        cab.addEventListener('click', function () {
          var panel = cab.closest('[data-pestana-panel]');
          if (!panel) return;
          var estaAbierto = panel.classList.contains('pestanas-producto-acordeon-abierto');

          if (estaAbierto) {
            cerrarAcordeon(panel);
          } else {
            paneles.forEach(function (p) {
              cerrarAcordeon(p);
            });
            abrirAcordeon(panel);
          }
        });
      });

      var contenidosParciales = root.querySelectorAll('[data-acordeon-contenido]');
      contenidosParciales.forEach(function (cont) {
        cont.addEventListener('click', function () {
          var panel = cont.closest('[data-pestana-panel]');
          if (!panel) return;
          if (panel.classList.contains('pestanas-producto-acordeon-parcial')) {
            expandirCompleto(panel);
          }
        });
      });

      var panelesParcialDesktop = root.querySelectorAll('[data-parcial-desktop]');
      panelesParcialDesktop.forEach(function (panel) {
        var cont = panel.querySelector('[data-acordeon-contenido]');
        if (!cont) return;
        cont.addEventListener('click', function () {
          if (window.innerWidth >= 990 && !panel.classList.contains('pestanas-producto-expandido-desktop')) {
            panel.classList.add('pestanas-producto-expandido-desktop');
          }
        });
      });
    }

    function initTodas() {
      document.querySelectorAll('[data-pestanas-producto]').forEach(initPestanasProducto);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTodas);
    } else {
      initTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var seccion = e.target.querySelector('[data-pestanas-producto]');
      if (seccion) initPestanasProducto(seccion);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var boton = e.target.querySelector('.pestanas-producto-boton');
      if (boton) boton.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-product-banner-03"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSeccion(seccion) {
    if (!seccion || seccion.dataset.featprodInit === 'true') return;
    seccion.dataset.featprodInit = 'true';

    if (seccion.dataset.featprodAnim !== '1') return;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var animables = seccion.querySelectorAll('.featprod-anim');
    if (!animables.length) return;

    var retraso = parseInt(seccion.dataset.featprodRetraso, 10);
    if (isNaN(retraso)) retraso = 100;

    Array.prototype.forEach.call(animables, function (el) {
      var i = parseInt(el.dataset.featprodAnimIdx, 10);
      if (isNaN(i)) i = 0;
      el.style.transitionDelay = (i * retraso) + 'ms';
    });

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(animables, function (el) {
        el.classList.add('featprod-anim-visible');
      });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('featprod-anim-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    Array.prototype.forEach.call(animables, function (el) { obs.observe(el); });
  }

  /* Arranca los vídeos de fondo sólo cuando la sección se acerca al viewport.
     Con preload="none" y sin autoplay, hasta ese momento no se descarga un byte.
     El play() programático está permitido sin gesto del usuario porque el vídeo
     es muted; forzamos la propiedad además del atributo por si el navegador la
     hubiera reseteado. */
  function initVideos(seccion) {
    if (!seccion || seccion.dataset.featprodVideoInit === 'true') return;
    seccion.dataset.featprodVideoInit = 'true';

    var videos = seccion.querySelectorAll('.featprod-media--video');
    if (!videos.length) return;

    function arrancar(v) {
      v.muted = true;
      try {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, arrancar);
      return;
    }

    var obsVid = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        arrancar(entry.target);
        obsVid.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });

    Array.prototype.forEach.call(videos, function (v) { obsVid.observe(v); });
  }

  function init() {
    document.querySelectorAll('[data-featprod-seccion]').forEach(function (s) {
      initSeccion(s);
      initVideos(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = (e.target.matches && e.target.matches('[data-featprod-seccion]'))
      ? e.target
      : (e.target.querySelector && e.target.querySelector('[data-featprod-seccion]'));
    if (s) {
      delete s.dataset.featprodInit;
      delete s.dataset.featprodVideoInit;
      initSeccion(s);
      initVideos(s);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-producto-destacado"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function dispararCartUpdated() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (data) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: data.item_count } }));
    }).catch(function () {});
  }

  function initBoton(boton) {
    if (boton.dataset.destInit === 'true') return;
    boton.dataset.destInit = 'true';

    boton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variant = boton.getAttribute('data-variant');
      if (!variant) return;

      var textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = 'Anadiendo...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variant, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('err');
        return r.json();
      }).then(function () {
        boton.classList.add('dest-boton-ok');
        boton.textContent = 'Anadido';
        dispararCartUpdated();
        setTimeout(function () {
          boton.disabled = false;
          boton.classList.remove('dest-boton-ok');
          boton.textContent = textoOriginal;
        }, 1600);
      }).catch(function () {
        boton.textContent = 'Error';
        setTimeout(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
        }, 2000);
      });
    });
  }

  function initAnim(seccion) {
    if (seccion.dataset.destAnimInit === 'true') return;
    seccion.dataset.destAnimInit = 'true';

    var tipoAnim = '';
    seccion.classList.forEach(function (c) {
      if (c.indexOf('dest-anim-') === 0 && c !== 'dest-anim-visible' && c.indexOf('dest-anim-seq-') !== 0) tipoAnim = c;
    });

    if (tipoAnim === 'dest-anim-ninguna' || tipoAnim === '') {
      seccion.classList.add('dest-anim-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      seccion.classList.add('dest-anim-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('dest-anim-visible');
          observer.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    observer.observe(seccion);
  }

  function initAll() {
    document.querySelectorAll('[data-dest-add]').forEach(initBoton);
    document.querySelectorAll('[data-dest-seccion]').forEach(initAnim);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-dest]')) {
      var seccion = e.target.querySelector('[data-dest-seccion]');
      if (seccion) {
        seccion.dataset.destAnimInit = '';
      }
      initAll();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-productos-recomendados"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function dispararCartUpdated() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (data) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: data.item_count } }));
    }).catch(function () {});
  }

  function initBotones(root) {
    root.querySelectorAll('[data-reco-add]').forEach(function (boton) {
      if (boton.dataset.recoInit === 'true') return;
      boton.dataset.recoInit = 'true';
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variant = boton.getAttribute('data-variant');
        if (!variant) return;
        var textoOriginal = boton.textContent;
        boton.disabled = true;
        boton.textContent = 'Anadiendo...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variant, 10), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('err');
          return r.json();
        }).then(function () {
          boton.classList.add('reco-boton-ok');
          boton.textContent = 'Anadido';
          dispararCartUpdated();
          setTimeout(function () {
            boton.disabled = false;
            boton.classList.remove('reco-boton-ok');
            boton.textContent = textoOriginal;
          }, 1600);
        }).catch(function () {
          boton.textContent = 'Error';
          setTimeout(function () {
            boton.disabled = false;
            boton.textContent = textoOriginal;
          }, 2000);
        });
      });
    });
  }

  function initFlechas(root) {
    var track = root.querySelector('[data-reco-track]');
    var prev = root.querySelector('[data-reco-prev]');
    var next = root.querySelector('[data-reco-next]');
    if (!track) return;
    function paso() {
      var tarjeta = track.querySelector('.reco-tarjeta');
      if (!tarjeta) return track.clientWidth;
      var estilo = getComputedStyle(track);
      var gap = parseInt(estilo.columnGap || estilo.gap, 10) || 0;
      return tarjeta.getBoundingClientRect().width + gap;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
  }

  function igualarNombres(root) {
    var nombres = root.querySelectorAll('.reco-nombre');
    if (!nombres.length) return;
    nombres.forEach(function (n) { n.style.minHeight = ''; });
    var max = 0;
    nombres.forEach(function (n) { if (n.offsetHeight > max) max = n.offsetHeight; });
    nombres.forEach(function (n) { n.style.minHeight = max + 'px'; });
  }

  function initSeccion(root) {
    igualarNombres(root);
    if (root.dataset.recoSeccionInit === 'true') return;
    root.dataset.recoSeccionInit = 'true';
    initBotones(root);
    initFlechas(root);
  }

  function initAll() {
    document.querySelectorAll('.reco-seccion').forEach(initSeccion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.reco-seccion');
    if (s) {
      s.dataset.recoSeccionInit = '';
      initSeccion(s);
    }
  });

  window.addEventListener('load', function () {
    document.querySelectorAll('.reco-seccion').forEach(igualarNombres);
  });

  var recoResizeT;
  window.addEventListener('resize', function () {
    clearTimeout(recoResizeT);
    recoResizeT = setTimeout(function () {
      document.querySelectorAll('.reco-seccion').forEach(igualarNombres);
    }, 150);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-testimonios-02"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function inicializarTestimonios(seccion) {
    if (!seccion || seccion.dataset.testimoniosInit === 'true') return;
    seccion.dataset.testimoniosInit = 'true';

    var slider = seccion.querySelector('[data-testimonios-slider]');
    var track = seccion.querySelector('[data-testimonios-track]');
    var cards = Array.prototype.slice.call(seccion.querySelectorAll('[data-testimonios-card]'));
    var prevBtn = seccion.querySelector('[data-testimonios-prev]');
    var nextBtn = seccion.querySelector('[data-testimonios-next]');
    var dotsCont = seccion.querySelector('[data-testimonios-dots]');

    if (!track || cards.length === 0) return;

    var indiceActual = 0;

    function visibles() {
      var val = getComputedStyle(track).getPropertyValue('--tarjetas-visibles');
      var n = parseInt(val, 10);
      if (!n || n < 1) n = 1;
      return Math.min(n, cards.length);
    }

    function maxIndice() {
      return Math.max(0, cards.length - visibles());
    }

    function gapPx() {
      var cs = getComputedStyle(track);
      var g = parseFloat(cs.columnGap);
      if (isNaN(g)) g = parseFloat(cs.gap);
      return isNaN(g) ? 0 : g;
    }

    function actualizar() {
      if (!cards[0]) return;
      var ancho = cards[0].getBoundingClientRect().width;
      var gap = gapPx();
      var offset = indiceActual * (ancho + gap);
      track.style.setProperty('transform', 'translateX(-' + offset + 'px)', 'important');

      if (dotsCont) {
        var dots = dotsCont.querySelectorAll('.testimonios-dot');
        for (var i = 0; i < dots.length; i++) {
          if (i === indiceActual) {
            dots[i].classList.add('testimonios-dot--activo');
          } else {
            dots[i].classList.remove('testimonios-dot--activo');
          }
        }
      }

      var mx = maxIndice();
      if (prevBtn) {
        if (indiceActual <= 0) {
          prevBtn.classList.add('testimonios-flecha--inactiva');
        } else {
          prevBtn.classList.remove('testimonios-flecha--inactiva');
        }
      }
      if (nextBtn) {
        if (indiceActual >= mx) {
          nextBtn.classList.add('testimonios-flecha--inactiva');
        } else {
          nextBtn.classList.remove('testimonios-flecha--inactiva');
        }
      }

      if (slider) {
        if (indiceActual > 0) {
          slider.classList.add('tiene-prev');
        } else {
          slider.classList.remove('tiene-prev');
        }
        if (indiceActual < mx) {
          slider.classList.add('tiene-next');
        } else {
          slider.classList.remove('tiene-next');
        }
      }
    }

    function construirDots() {
      if (!dotsCont) return;
      dotsCont.innerHTML = '';
      var mx = maxIndice();
      for (var i = 0; i <= mx; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonios-dot' + (i === indiceActual ? ' testimonios-dot--activo' : '');
        dot.setAttribute('aria-label', 'Ir al testimonio ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function (e) {
            e.preventDefault();
            indiceActual = idx;
            actualizar();
          });
        })(i);
        dotsCont.appendChild(dot);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (indiceActual > 0) {
          indiceActual--;
          actualizar();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (indiceActual < maxIndice()) {
          indiceActual++;
          actualizar();
        }
      });
    }

    var touchStartX = 0;
    var touchStartY = 0;
    var swiping = false;

    track.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches[0]) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      swiping = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!swiping || !e.changedTouches || !e.changedTouches[0]) return;
      swiping = false;
      var diffX = touchStartX - e.changedTouches[0].clientX;
      var diffY = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        if (diffX > 0 && indiceActual < maxIndice()) {
          indiceActual++;
        } else if (diffX < 0 && indiceActual > 0) {
          indiceActual--;
        }
        actualizar();
      }
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        indiceActual = Math.min(indiceActual, maxIndice());
        construirDots();
        actualizar();
      }, 150);
    }, { passive: true });

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        actualizar();
      });
      ro.observe(track);
    }

    construirDots();
    if (window.requestAnimationFrame) {
      requestAnimationFrame(actualizar);
    } else {
      setTimeout(actualizar, 0);
    }
  }

  function iniciarTodas() {
    var secciones = document.querySelectorAll('[data-testimonios-seccion]');
    for (var i = 0; i < secciones.length; i++) {
      inicializarTestimonios(secciones[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = (e.target.matches && e.target.matches('[data-testimonios-seccion]'))
      ? e.target
      : (e.target.querySelector && e.target.querySelector('[data-testimonios-seccion]'));
    if (seccion) {
      delete seccion.dataset.testimoniosInit;
      inicializarTestimonios(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomate-ventana-afiliados"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function animarNumero(numEl, duracion, callback) {
    var texto = numEl.textContent;
    var match = texto.match(/(\d+(?:[.,]\d+)?)/);
    if (!match) {
      callback();
      return;
    }
    var numStr = match[1];
    var finalNum = parseFloat(numStr.replace(',', '.'));
    var usarComa = numStr.indexOf(',') !== -1;
    var sepIdx = numStr.search(/[.,]/);
    var decimales = sepIdx === -1 ? 0 : (numStr.length - sepIdx - 1);
    var prefijo = texto.substring(0, match.index);
    var sufijo = texto.substring(match.index + numStr.length);
    var inicio = null;

    if (finalNum === 0) {
      callback();
      return;
    }

    function paso(ahora) {
      if (inicio === null) inicio = ahora;
      var t = Math.min((ahora - inicio) / duracion, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var valor = finalNum * eased;
      var salida = decimales > 0 ? valor.toFixed(decimales) : Math.floor(valor).toString();
      if (usarComa) salida = salida.replace('.', ',');
      numEl.textContent = prefijo + salida + sufijo;
      if (t < 1) {
        requestAnimationFrame(paso);
      } else {
        numEl.textContent = texto;
        callback();
      }
    }

    requestAnimationFrame(paso);
  }

  function dispararDestacado(raiz) {
    if (raiz.dataset.modalafDestacadoAnim !== '1') return;
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var contenedor = raiz.querySelector('[data-modalAf-destacado]');
    var numEl = raiz.querySelector('[data-modalAf-destacado-num]');
    if (!contenedor || !numEl) return;

    var textoOriginal = numEl.getAttribute('data-modalAf-texto-original');
    if (!textoOriginal) {
      textoOriginal = numEl.textContent;
      numEl.setAttribute('data-modalAf-texto-original', textoOriginal);
    } else {
      numEl.textContent = textoOriginal;
    }

    var duracion = parseInt(raiz.dataset.modalafDestacadoDur, 10);
    if (isNaN(duracion) || duracion <= 0) duracion = 1400;

    contenedor.classList.remove('modalAf-destacado-numero--pop');
    void contenedor.offsetWidth;

    animarNumero(numEl, duracion, function () {
      contenedor.classList.add('modalAf-destacado-numero--pop');
    });
  }

  function initModal(raiz) {
    if (!raiz || raiz.dataset.modalafInit === 'true') return;
    raiz.dataset.modalafInit = 'true';

    var anchor = raiz.dataset.modalafAnchor || raiz.getAttribute('data-modalAf-anchor');
    if (!anchor) return;

    var modal = raiz.querySelector('[data-modalAf-modal]');
    var overlay = raiz.querySelector('[data-modalAf-overlay]');
    var btnCerrar = raiz.querySelector('[data-modalAf-cerrar]');
    var ultimoFoco = null;

    function obtenerFocusables() {
      return modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    }

    function abrir() {
      if (raiz.classList.contains('modalAf-abierto')) return;
      ultimoFoco = document.activeElement;
      raiz.classList.add('modalAf-abierto');
      raiz.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modalAf-body-bloqueado');
      void raiz.offsetWidth;
      requestAnimationFrame(function () {
        raiz.classList.add('modalAf-visible');
        setTimeout(function () {
          dispararDestacado(raiz);
        }, 200);
      });
      setTimeout(function () {
        if (modal && typeof modal.focus === 'function') modal.focus();
      }, 50);
    }

    function cerrar() {
      if (!raiz.classList.contains('modalAf-abierto')) return;
      raiz.classList.remove('modalAf-visible');
      setTimeout(function () {
        raiz.classList.remove('modalAf-abierto');
        raiz.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modalAf-body-bloqueado');
        if (ultimoFoco && typeof ultimoFoco.focus === 'function') {
          try { ultimoFoco.focus(); } catch (e) {}
        }
        if (window.location.hash === '#' + anchor) {
          if (history.replaceState) {
            history.replaceState(null, '', window.location.pathname + window.location.search);
          }
        }
      }, 350);
    }

    function esEnlaceQueAbre(el) {
      if (!el || el.tagName !== 'A') return false;
      var href = el.getAttribute('href') || '';
      if (href === '#' + anchor) return true;
      if (href.indexOf('#' + anchor) > -1) {
        try {
          var url = new URL(href, window.location.href);
          if (url.hash === '#' + anchor) {
            if (url.pathname === window.location.pathname || (url.pathname === '/' && window.location.pathname === '/')) {
              return true;
            }
            return false;
          }
        } catch (e) {
          return false;
        }
      }
      return false;
    }

    document.addEventListener('click', function (e) {
      var el = e.target;
      while (el && el !== document.body) {
        if (el.tagName === 'A' && esEnlaceQueAbre(el)) {
          e.preventDefault();
          abrir();
          if (history.replaceState) {
            history.replaceState(null, '', '#' + anchor);
          }
          return;
        }
        el = el.parentNode;
      }
    });

    if (overlay) overlay.addEventListener('click', cerrar);
    if (btnCerrar) btnCerrar.addEventListener('click', cerrar);

    document.addEventListener('keydown', function (e) {
      if (!raiz.classList.contains('modalAf-abierto')) return;
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        cerrar();
        return;
      }
      if (e.key === 'Tab' || e.keyCode === 9) {
        var focusables = obtenerFocusables();
        if (focusables.length === 0) {
          e.preventDefault();
          return;
        }
        var primero = focusables[0];
        var ultimo = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === primero) {
          e.preventDefault();
          ultimo.focus();
        } else if (!e.shiftKey && document.activeElement === ultimo) {
          e.preventDefault();
          primero.focus();
        }
      }
    });

    if (window.location.hash === '#' + anchor) {
      setTimeout(abrir, 50);
    }

    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#' + anchor) abrir();
    });
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-modalAf-raiz]').forEach(initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var raiz = (e.target.matches && e.target.matches('[data-modalAf-raiz]'))
      ? e.target
      : (e.target.querySelector && e.target.querySelector('[data-modalAf-raiz]'));
    if (raiz) {
      delete raiz.dataset.modalafInit;
      initModal(raiz);
    }
  });

  document.addEventListener('shopify:section:select', function (e) {
    if (!e.target.querySelector) return;
    var raiz = e.target.querySelector('[data-modalAf-raiz]');
    if (raiz) {
      raiz.classList.add('modalAf-abierto');
      requestAnimationFrame(function () {
        raiz.classList.add('modalAf-visible');
        setTimeout(function () {
          dispararDestacado(raiz);
        }, 200);
      });
      document.body.classList.add('modalAf-body-bloqueado');
    }
  });

  document.addEventListener('shopify:section:deselect', function (e) {
    if (!e.target.querySelector) return;
    var raiz = e.target.querySelector('[data-modalAf-raiz]');
    if (raiz) {
      raiz.classList.remove('modalAf-visible');
      setTimeout(function () {
        raiz.classList.remove('modalAf-abierto');
        document.body.classList.remove('modalAf-body-bloqueado');
      }, 350);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
